// import {
//   addExpenseApi,
//   getAccountFreghtList,
//   getChartExpense,
//   getChartRecipt,
//   getCommonExpenseApi,
//   getExpense,
//   getUserAccountList,
//   handleKeyDown,
//   uploadFiles,
// } from "_services";
// import {
//   CommonCanvas,
//   CommonDatePicker,
//   CommonInput,
//   CrossButton,
//   CustomSelect,
//   LoaderButton,
//   SkeletonInput,
//   CityDropdownForTrip,
// } from "components";
// import { Images } from "constants";
// import { UserContext } from "context";
// import { addTransationConsignor, addTransationFreight } from "features";
// import { errorSchema, utils } from "helper";
// import AddEditModal from "modals/AddEditModal";
// import moment from "moment";
// import Loading from "pages/Loading";
// import React, { useContext, useEffect, useState, useCallback, useRef } from "react";
// import toast from "react-hot-toast";
// import { IoCloseCircle } from "react-icons/io5";
// import { useDispatch } from "react-redux";
// import StorageService from "utils/StorageServices/StorageServices";

// const arryOptions = [
//   { label: "Arjun", value: "01" },
//   { label: "Anvit", value: "02" },
// ];

// const DROPDOWN_PAGE_SIZE = 20;

// const ClaimCanvas = (props) => {
//   const {
//     lrDetails,
//     tripId,
//     isOpen,
//     closeModal,
//     callBackFreight,
//     transactionList,
//   } = props;

//   const initiFrom = {
//     submitType: 1,
//     category: "",
//     sub_category: "",
//     expense_category: "",
//     amount: "",
//     txn_date: new Date(),
//     account_category: "",
//     account_sub_category: "",
//     account_id: "",
//     description: "",
//     vendor_type: "",
//     vendor_account: "",
//     lr_id: "",
//     trip_id: props?.tripId,
//     branch_id: "",
//     company_id: StorageService.getCompanyId(),
//     vehicle_id: "",
//     file: [],
//     checkForParty: false,
//     party_expense_category: "",
//     party_amount: "",
//     party_txn_date: new Date(),
//     party_account_sub_category: "",
//     party_account_id: "",
//     party_description: "",
//     supplier_account: false,
//     vendor_bank_account: "",
//     party_file: [],
//   };

//   const {
//     masterData,
//     globTripDetails,
//     bankDetails,
//     setModalZIndex,
//     modalZIndex,
//     setBankDetails,
//     userSettingPermission
//   } = useContext(UserContext);

//   const dispatch = useDispatch();
//   const companyIdRef = useRef(StorageService.getCompanyId());

//   const [form, setForm] = useState(initiFrom);
//   const [formError, setFormError] = useState("");
//   const [claimTypeList, setClaimTypeList] = useState([]);
//   const [claimAccount, setClaimAccount] = useState([]);
//   const [accountPartyType, setAccountPartyType] = useState("");
//   const [accountSupplierType, setAccountSupplierType] = useState("");
//   const [expenseList, setExpenseList] = useState([]);
//   const [accountList, setAccountList] = useState([]);
//   const [commExpenseList, setCommExpenseList] = useState([]);
//   const [accountList2, setAccountList2] = useState([]);
//   const [isLoadding, setIsLoadding] = useState(false);
//   const [isCheck, setIsCheck] = useState(bankDetails ? true : false);
//   const [bankAccountList, setBankAccountList] = useState([]);
//   const [accountLoading, setAccountLoading] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [reciptList, setReciptList] = useState([]);
//   const [expenseDetails, setExpenseDetails] = useState("");
//   const [receiptDetails, setReceiptDetails] = useState("");
//   const [isloadingSend, setIsloadingSend] = useState(false);
//   const [isOpenFuelModal, setIsOpenFuelModal] = useState(false);
//   const [selectedExpenseCategory, setSelectedExpenseCategory] = useState(null);
//   const [selectedPartCategory, setSelectedPartCategory] = useState(null);

//   const balance = props?.transactionList?.freight_summary?.balance;

//   // Fetch expense categories with lazy loading
//   const fetchExpenseCategories = useCallback(async (search, page, limit, expense) => {
//     try {
//       const payload = {
//         company_id: companyIdRef.current,
//         category_id: expense === 1 ? 5 : 4,
//         sub_category_id: expense === 1 ? 4 : 3,
//         search: search || "",
//         offset: page,
//         limit,
//       };
//       const res = await getCommonExpenseApi(payload);

//       if (res?.responseCode === 200) {
//         const details = res.data.categories?.map((item) => ({
//           ...item,
//           label: item.name,
//           value: item._id,
//         })) || [];

//         setExpenseDetails(res?.data || {});

//         return {
//           items: details,
//           total: res.data.total_record || details.length,
//         };
//       }

//       toast.error(res?.responseMessage);
//       return { items: [], total: 0 };
//     } catch (error) {
//       console.error("Error fetching expense categories:", error);
//       return { items: [], total: 0 };
//     }
//   }, []);

//   // Wrapper function for expense categories that includes sub_category
//   const fetchExpenseCategoriesWithSubCategory = useCallback(
//     (search, page, limit) => {
//       return fetchExpenseCategories(search, page, limit, form?.sub_category);
//     },
//     [form?.sub_category, fetchExpenseCategories]
//   );

//   useEffect(() => {
//     if (form?.sub_category) {
//       handleOnChange("expense_category", "");
//       setSelectedExpenseCategory(null);
//       setSelectedPartCategory(null);
//       setExpenseDetails({});
//     }
//   }, [form?.sub_category]);

//   useEffect(() => {
//     getMasterFreight();
//   }, [masterData]);

//   useEffect(() => {
//     if (accountSupplierType) {
//       setForm({ ...form, account_id: "" });
//     }
//   }, [accountSupplierType]);

//   useEffect(() => {
//     if (accountPartyType) {
//       setForm({ ...form, party_account_id: "" });
//     }
//   }, [accountPartyType]);

//   useEffect(() => {
//     if (form?.account_sub_category != 10 && form?.account_category) {
//       if (form?.account_id == "") {
//         setIsCheck(false);
//         getAccountListHandler();
//       }
//     }
//   }, [form?.account_sub_category, form?.account_category, form?.account_id]);

//   useEffect(() => {
//     if (
//       form?.party_account_sub_category != 10 &&
//       form?.account_category &&
//       accountList?.length
//     ) {
//       getAccountListHandler2();
//       if (form?.party_account_id == "") {
//       }
//     }
//   }, [
//     form?.party_account_sub_category,
//     form?.account_category,
//     accountList,
//     form?.party_account_id,
//   ]);

//   useEffect(() => {
//     if (props?.accountList?.length > 0) {
//       let list = props?.accountList?.map((i) => {
//         return {
//           ...i,
//           label: i?.bank_name ? i?.bank_name : i?.upi_id,
//           value: i?._id,
//         };
//       });
//       setBankAccountList(list);
//     }
//   }, [props?.accountList]);

//   useEffect(() => {
//     if (bankDetails) {
//       handleOnChange("vendor_bank_account", bankDetails?._id);
//     }
//   }, [bankDetails]);

//   useEffect(() => {
//     if (!isCheck) {
//       setBankDetails("");
//       if (form?.vendor_account) {
//         setForm({ ...form, vendor_account: "" });
//       }
//     } else {
//       setForm({ ...form, vendor_account: bankAccountList[0]?._id });
//       setBankDetails(bankAccountList[0])
//     }
//   }, [isCheck]);

//   const getMasterFreight = async () => {
//     try {
//       const details = masterData?.supplier_claims?.sub_type?.map((item) => {
//         return {
//           label: item?.name,
//           value: item?.id,
//           id: item?.id,
//           status: item?.status,
//           category_id: masterData?.supplier_claims?.id,
//           type: masterData?.supplier_claims?.type,
//         };
//       });

//       const final = details?.reverse();
//       const detailsAccount =
//         masterData?.market_account_category?.sub_category?.map((item) => {
//           return {
//             label: item?.name,
//             value: item?.id,
//             category_id: masterData?.market_account_category?.id,
//           };
//         });

//       const reorderedItems = detailsAccount.filter(
//         (item) => item.label !== "Balance"
//       );
//       const cashItem = detailsAccount.find((item) => item.label === "Balance");
//       let list = [cashItem];

//       if (list.length && details) {
//         setForm({
//           ...form,
//           trip_id: tripId,
//           category: final[0]?.category_id,
//           sub_category: final[0]?.value,
//           account_category: list[0]?.category_id,
//           account_sub_category: list[0]?.value,
//           party_account_sub_category: list[0]?.value,
//         });

//         setClaimTypeList(final);
//         setClaimAccount(list);
//       }
//     } catch { }
//   };

//   const getAccountListHandler = async () => {
//     setAccountLoading(true);
//     try {
//       const res = await getUserAccountList({
//         company_id: StorageService?.getCompanyId(),
//         category_id: parseInt(form?.account_category),
//         sub_category_id: parseInt(form?.account_sub_category),
//         account_id: "",
//       });

//       if (res?.responseCode === 200) {
//         setAccountLoading(false);
//         const details = res?.data?.account_list?.map((item) => ({
//           ...item,
//           label: item?.name,
//           value: item?._id,
//         }));

//         setAccountList(details);
//         if (details.length > 0) {
//           handleOnChange("account_id", details[0].value);
//         }
//       } else {
//         setAccountLoading(false)
//         setAccountList([]);
//       }
//     } catch (error) {
//       setAccountLoading(false)
//       setAccountList([]);
//     } finally {
//       setAccountLoading(false)
//     }
//   };

//   const getAccountListHandler2 = async () => {
//     setAccountLoading(true);
//     try {
//       const res = await getUserAccountList({
//         company_id: StorageService?.getCompanyId(),
//         category_id: parseInt(form?.account_category),
//         sub_category_id: parseInt(form?.party_account_sub_category),
//         account_id: "",
//       });

//       if (res?.responseCode === 200) {
//         setAccountLoading(false);
//         const details = res?.data?.account_list?.map((item) => ({
//           ...item,
//           label: item?.name,
//           value: item?._id,
//         }));
//         setAccountList2(details);
//         if (details.length > 0) {
//           handleOnChange("party_account_id", details[0].value);
//         }
//       } else {
//         setAccountLoading(false);
//       }
//     } catch (error) {
//     } finally {
//       setAccountLoading(false);
//     }
//   };

//   const handleOnChange = async (name, value) => {
//     const stateObj = {
//       ...form,
//       [name]: value,
//     };

//     if (name === "expense_category") {
//       stateObj.party_expense_category = value;
//     }
//     if (name === "amount") {
//       stateObj.party_amount = value;
//     }
//     if (name === "description") {
//       stateObj.party_description = value;
//     }
//     if (name === "txn_date") {
//       stateObj.party_txn_date = value;
//     }
//     if (name === "account_sub_category") {
//       stateObj.party_account_sub_category = value;
//     }
//     if (name === "account_id") {
//       stateObj.party_account_id = value;
//     }
//     if (name === "supplier_account") {
//       stateObj.vendor_bank_account = "";
//     }
//     setForm(stateObj);

//     if (!!formError) {
//       const validationResult = await utils.checkFormError(
//         { ...stateObj, balance: balance },
//         errorSchema.addClaimFullSchema
//       );

//       if (validationResult === true) {
//         setFormError("");
//       } else {
//         setFormError(validationResult);
//       }
//     }
//   };

//   const onSubmitClaim = async (approve) => {
//     const validationResult = await utils.checkFormError(
//       { ...form, balance: balance },
//       errorSchema.addClaimFullSchema
//     );

//     const payloadforSupplier = {
//       type: form?.category ? parseInt(form?.category) : "",
//       sub_type: form?.sub_category ? parseInt(form?.sub_category) : "",
//       expense_category: form?.expense_category,
//       amount: form?.amount,
//       date: utils.convertToISO(form?.txn_date, true),
//       account_category: form?.account_category
//         ? parseInt(form?.account_category)
//         : "",
//       account_sub_category: form?.account_sub_category
//         ? parseInt(form?.account_sub_category)
//         : "",
//       account_id: form?.account_id ? form?.account_id : "",
//       description: form?.description,
//       vendor_bank_account: bankDetails ? bankDetails?._id : "",
//       lr_id: lrDetails?._id,
//       trip_id: props.tripId,
//       branch_id: globTripDetails?.branch_id?._id,
//       company_id: form?.company_id,
//       vehicle_id: globTripDetails?.vehicle_id?._id,
//       file: form?.file,
//       is_approval: approve,
//     };

//     const payloadforConsignor = {
//       type: form?.category ? parseInt(form?.category) : "",
//       sub_type: form?.sub_category ? parseInt(form?.sub_category) : "",
//       expense_category: form?.party_expense_category,
//       amount: form?.party_amount,
//       date: utils.convertToISO(form?.txn_date, true),
//       account_category: form?.account_category
//         ? parseInt(form?.account_category)
//         : "",
//       account_sub_category: form?.party_account_sub_category
//         ? parseInt(form?.party_account_sub_category)
//         : "",
//       account_id: form?.party_account_id
//         ? parseInt(form?.party_account_id)
//         : "",
//       description: form?.party_description,
//       vendor_bank_account: "",
//       lr_id: lrDetails?._id,
//       trip_id: props.tripId,
//       branch_id: globTripDetails?.branch_id?._id,
//       company_id: form?.company_id,
//       vehicle_id: globTripDetails?.vehicle_id?._id,
//       file: form?.party_file,
//       is_approval: approve,
//     };

//     setFormError(validationResult);

//     if (validationResult === true) {
//       approve == 0 ? setIsLoadding(true) : setIsloadingSend(true);
//       try {
//         if (form?.checkForParty) {
//           const resForSupplier = await dispatch(
//             addTransationFreight(payloadforSupplier)
//           );
//           const resForParty = await dispatch(
//             addTransationConsignor(payloadforConsignor)
//           );

//           if (
//             resForSupplier?.payload?.responseCode === 200 &&
//             resForParty?.payload?.responseCode === 200
//           ) {
//             setIsLoadding(false);
//             setIsloadingSend(false);
//             closeModal();
//             callBackFreight();
//             setBankDetails("");
//           } else {
//             setIsLoadding(false);
//             setIsloadingSend(false);
//           }
//         } else {
//           const resForSupplier = await dispatch(
//             addTransationFreight(payloadforSupplier)
//           );

//           if (resForSupplier?.payload?.responseCode === 200) {
//             setIsLoadding(false);
//             setIsloadingSend(false);
//             closeModal();
//             callBackFreight();
//             setBankDetails("");
//           } else {
//             setIsLoadding(false);
//             setIsloadingSend(false);
//           }
//         }
//       } catch {
//         setIsLoadding(false);
//         setIsloadingSend(false);
//       }
//     } else {
//       setFormError(validationResult);
//       setIsLoadding(false);
//       setIsloadingSend(false);
//     }
//   };

//   const continueHnadle = async () => {
//     const validationResult = await utils.checkFormError(
//       { ...form, balance: balance },
//       errorSchema.addClaimSchema
//     );

//     if (validationResult === true) {
//       setForm({ ...form, submitType: 2 });
//     } else {
//       setFormError(validationResult);
//     }
//   };

//   const validateInput = (value) => {
//     const number = parseFloat(value);
//     return number <= transactionList?.freight_summary?.freight_summary?.balance;
//   };

//   const backButton = () => {
//     setForm({ ...form, submitType: 1 });
//   };

//   const handleFileChange = async (e, type) => {
//     if (
//       e?.target?.files[0]?.type === "image/gif" ||
//       e?.target?.files[0]?.type === "image/jpeg" ||
//       e?.target?.files[0]?.type === "image/png"
//     ) {
//       setLoading(true);
//       try {
//         const formData = new FormData();
//         formData.append("file", e?.target?.files[0]);
//         const res = await uploadFiles(formData);
//         if (res?.responseCode === 200) {
//           var fileArray = [];

//           if (type == "first") {
//             fileArray.push(...form?.file, {
//               filename: res?.data?.filename,
//               path: res?.data?.path,
//             });
//             handleOnChange("file", fileArray);
//           } else {
//             fileArray.push(...form?.party_file, {
//               filename: res?.data?.filename,
//               path: res?.data?.path,
//             });
//             handleOnChange("party_file", fileArray);
//           }

//           setLoading(false);
//           toast.success("Document added ");
//         }
//       } catch (error) {
//         setLoading(false);
//       }
//     } else {
//       toast.error("Invalid file, choose jpeg/png images");
//     }
//   };

//   const documentRemove = (index) => {
//     const newFromIput = [...form?.file];
//     newFromIput.splice(index, 1);
//     setForm({ ...form, file: newFromIput });
//   };

//   const partyDocumentRemove = (index) => {
//     const newFromIput = [...form?.party_file];
//     newFromIput.splice(index, 1);
//     setForm({ ...form, party_file: newFromIput });
//   };

//   const isExpense = form?.sub_category == 1;
//   const categoryLabel = isExpense ? "Expense Category" : "Receipt Category";
//   const categoryPlace = isExpense
//     ? "Select Expense Category"
//     : " Select Receipt Category";

//   const totalbalance = props?.transactionList?.freight_summary?.balance || 0;
//   const amount = form?.amount || 0;
//   const result = balance - amount;

//   const callBackApi = (data) => {
//     const newCategory = data?.category;
//     if (newCategory) {
//       handleOnChange("expense_category", newCategory?._id);
//       // Set the selected category object for prefilling dropdown
//       setSelectedExpenseCategory({
//         value: newCategory?._id,
//         label: newCategory?.name,
//         ...newCategory
//       });
//       // Also set party category
//       setSelectedPartCategory({
//         value: newCategory?._id,
//         label: newCategory?.name,
//         ...newCategory
//       });
//     }
//     // callBackFreight();
//   };

//   const addExpenseHandle = (data) => {
//     setIsOpenFuelModal(true);
//   };

//   let openZoneModal = {
//     isOpen: isOpenFuelModal,
//     closeModal: (e) => setIsOpenFuelModal(false),
//     modalMainClass: "_dashCommon_Modal _smModal",
//     modalTitle: form?.sub_category == 1 ? 'Add Trip Expenses' : 'Add Trip Receipt',
//     submitTitle: form?.sub_category == 1 ? 'Add Trip Expenses' : 'Add Trip Receipt',
//     footerPart: true,
//     label: form?.sub_category == 1 ? 'Expenses Name' : 'Receipt Name',
//     placeholder: form?.sub_category == 1 ? 'Enter Expenses Name' : 'Enter Receipt Name',
//     ApiPoint: addExpenseApi,
//     callBackApi: callBackApi,
//     payloadData: {
//       category_id: form?.sub_category == 1 ? 5 : 4,
//       sub_category_id: form?.sub_category == 1 ? 4 : 3,
//     },
//     titleName: "Trip"
//   }

//   return (
//     <div>
//       <div
//         className={`offcanvas offcanvas-end common_offCanvas ${isOpen ? "show" : ""
//           }`}
//         tabIndex={-1}
//         style={{
//           visibility: isOpen ? "visible" : "hidden",
//           display: modalZIndex ? "none" : "",
//         }}
//       >
//         {isOpen && (
//           <>
//             <div className="offcanvas-header headWith_back">
//               {form?.submitType !== 1 && (
//                 <button
//                   type="button"
//                   onClick={backButton}
//                   className="_modBack_btn"
//                 >
//                   <img src={Images.BACKICON} alt="" />
//                 </button>
//               )}
//               <h5 className="offcanvas-title">
//                 {form?.sub_category == 1
//                   ? "Claim Pay to Supplier"
//                   : "Claim Charge form Supplier"}{" "}
//               </h5>
//               <CrossButton type="button" className="_switchBtn  __animEffect_btn" style={{ marginLeft: 'auto' }} onClick={closeModal}>
//                 <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none" >
//                   <path
//                     d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
//                     fill="black"
//                   />
//                 </svg>
//               </CrossButton>
//             </div>

//             <>
//               {form.submitType === 1 ? (
//                 <>
//                   <div className="offcanvas-body">
//                     <div className="_lrCl_offCavBody __otr_expCanva">
//                       <div className="_othrExp_recBx">
//                         <div className="_lrl_otrBx selectedBxs">
//                           <div className="_lr_cnpCode">
//                             <h4 className="_lrl_cnp">
//                               {lrDetails?.consignor_id?.name}
//                             </h4>
//                             <h4 className="_lrl_code">
//                               # {lrDetails?.lr_number}
//                             </h4>
//                           </div>

//                           <div className="_lrlRout_ls">
//                             <div className="_lrHead_fsx">
//                               <h3>{lrDetails?.from_location}</h3>
//                               <p>
//                                 {utils.formatDateMonth(lrDetails.invoice_date)}
//                               </p>
//                             </div>

//                             <div>
//                               <svg
//                                 xmlns="http://www.w3.org/2000/svg"
//                                 width="136"
//                                 height="29"
//                                 viewBox="0 0 136 29"
//                                 fill="none"
//                               >
//                                 <path d="M0 15L51 15" stroke="#DFE8FF" />
//                                 <path d="M85 15L136 15" stroke="#DFE8FF" />
//                                 <circle
//                                   cx="67.5"
//                                   cy="14.5"
//                                   r="14.5"
//                                   fill="#DFE8FF"
//                                 />
//                                 <path
//                                   d="M63.5 6C62.837 6 62.2011 6.26339 61.7322 6.73223C61.2634 7.20107 61 7.83696 61 8.5V17.5C61 18.318 61.393 19.044 62 19.5V21.5C62 21.6326 62.0527 21.7598 62.1464 21.8536C62.2402 21.9473 62.3674 22 62.5 22H64.5C64.6326 22 64.7598 21.9473 64.8536 21.8536C64.9473 21.7598 65 21.6326 65 21.5V20H71V21.5C71 21.6326 71.0527 21.7598 71.1464 21.8536C71.2402 21.9473 71.3674 22 71.5 22H73.5C73.6326 22 73.7598 21.9473 73.8536 21.8536C73.9473 21.7598 74 21.6326 74 21.5V19.5C74.607 19.044 75 18.318 75 17.5V8.5C75 7.83696 74.7366 7.20107 74.2678 6.73223C73.7989 6.26339 73.163 6 72.5 6H63.5ZM63 9C63 8.73478 63.1054 8.48043 63.2929 8.29289C63.4804 8.10536 63.7348 8 64 8H72C72.2652 8 72.5196 8.10536 72.7071 8.29289C72.8946 8.48043 73 8.73478 73 9V12.9C73 13.525 72.438 13.992 71.83 13.894C70.925 13.747 69.208 13.5 68 13.5C66.792 13.5 65.075 13.747 64.17 13.894C64.0259 13.9175 63.8784 13.9093 63.7378 13.8702C63.5971 13.8311 63.4666 13.7618 63.3554 13.6673C63.2441 13.5728 63.1547 13.4552 63.0933 13.3227C63.032 13.1902 63.0001 13.046 63 12.9V9ZM64 18C63.7348 18 63.4804 17.8946 63.2929 17.7071C63.1054 17.5196 63 17.2652 63 17C63 16.7348 63.1054 16.4804 63.2929 16.2929C63.4804 16.1054 63.7348 16 64 16C64.2652 16 64.5196 16.1054 64.7071 16.2929C64.8946 16.4804 65 16.7348 65 17C65 17.2652 64.8946 17.5196 64.7071 17.7071C64.5196 17.8946 64.2652 18 64 18ZM72 18C71.7348 18 71.4804 17.8946 71.2929 17.7071C71.1054 17.5196 71 17.2652 71 17C71 16.7348 71.1054 16.4804 71.2929 16.2929C71.4804 16.1054 71.7348 16 72 16C72.2652 16 72.5196 16.1054 72.7071 16.2929C72.8946 16.4804 73 16.7348 73 17C73 17.2652 72.8946 17.5196 72.7071 17.7071C72.5196 17.8946 72.2652 18 72 18ZM67 16H69C69.2652 16 69.5196 16.1054 69.7071 16.2929C69.8946 16.4804 70 16.7348 70 17C70 17.2652 69.8946 17.5196 69.7071 17.7071C69.5196 17.8946 69.2652 18 69 18H67C66.7348 18 66.4804 17.8946 66.2929 17.7071C66.1054 17.5196 66 17.2652 66 17C66 16.7348 66.1054 16.4804 66.2929 16.2929C66.4804 16.1054 66.7348 16 67 16Z"
//                                   fill="#1450EC"
//                                 />
//                               </svg>
//                             </div>

//                             <div className="_lrHead_fsx _lrs_rSide">
//                               <h3>{lrDetails?.to_location}</h3>
//                             </div>
//                           </div>

//                           <div className="_lr_cnpCode">
//                             <h4 className="_lrl_code">
//                               INV- {lrDetails?.invoice_number}
//                             </h4>

//                             <p className="_lrl_stats">
//                               <span>
//                                 <svg
//                                   xmlns="http://www.w3.org/2000/svg"
//                                   width="12"
//                                   height="11"
//                                   viewBox="0 0 12 11"
//                                   fill="none"
//                                 >
//                                   <ellipse
//                                     cx="5.54354"
//                                     cy="5.5"
//                                     rx="5.54354"
//                                     ry="5.5"
//                                     fill="#22A57A"
//                                   />
//                                 </svg>
//                               </span>{" "}
//                               {masterData?.lr_status[lrDetails?.lr_status]
//                                 ? masterData?.lr_status[lrDetails?.lr_status]
//                                 : ""}{" "}
//                             </p>
//                           </div>
//                         </div>
//                       </div>
//                       <div className="_othrExp_recBx">
//                         <div className="_clPay_flex">
//                           <div className="singleDiv">
//                             <CommonDatePicker
//                               name="date"
//                               label="Transaction Date"
//                               startDate={form?.txn_date}
//                               setStartDate={(data) => {
//                                 handleOnChange("txn_date", data);
//                               }}
//                               error={formError?.txn_date}
//                               focus={!!formError?.txn_date}
//                             />
//                           </div>
//                           {claimTypeList.map((i) => {
//                             return (
//                               <div className="_dualCheckr_bx" key={i?.value}>
//                                 <input
//                                   className="form-check-input"
//                                   id={i?.value}
//                                   type="radio"
//                                   name="sub_category"
//                                   checked={i.value == form.sub_category}
//                                   value={i.value}
//                                   onChange={({ target: { name, value } }) =>
//                                     handleOnChange(name, value)
//                                   }
//                                 />
//                                 <label
//                                   htmlFor={i?.value}
//                                   className="form-check-label"
//                                 >
//                                   {i?.label}
//                                 </label>
//                               </div>
//                             );
//                           })}
//                           <div className="singleDiv">
//                             <CityDropdownForTrip
//                               label={categoryLabel}
//                               placeholder={categoryPlace}
//                               fetchData={fetchExpenseCategoriesWithSubCategory}
//                               pageSize={DROPDOWN_PAGE_SIZE}
//                               onChange={(data) => {
//                                 handleOnChange("expense_category", data.value);
//                                 setSelectedExpenseCategory(data);
//                               }}
//                               selectedItem={selectedExpenseCategory}
//                               error={formError?.expense_category}
//                               errorMessage={formError?.expense_category}
//                               focus={!!formError?.expense_category}
//                               isAddButton={true}
//                               addButtonAction={addExpenseHandle}
//                             />
//                           </div>
//                           <div className="singleDiv">
//                             <CommonInput
//                               type="textarea"
//                               label="Notes"
//                               placeholder="Notes"
//                               name="description"
//                               value={form?.description}
//                               onChange={({ target: { name, value } }) => {
//                                 handleOnChange(name, value);
//                               }}
//                               focus={!!formError?.description}
//                               error={formError.description}
//                             />
//                           </div>
//                         </div>
//                       </div>

//                       <div className="_othrExp_recBx">
//                         <div className="_clPay_flex">
//                           <div className="singleDiv">
//                             <div className="_payMode_hed">
//                               <h4>
//                                 {form.sub_category == 1
//                                   ? "Payment Mode"
//                                   : "Receipt Mode"}
//                               </h4>
//                               {claimAccount.map((i) => (
//                                 <button
//                                   key={i?.value}
//                                   className={`_baseSpan ${i?.value == form?.account_sub_category
//                                     ? ""
//                                     : "_bspDisable"
//                                     }`}
//                                   name="account_sub_category"
//                                   disabled={
//                                     form?.account_sub_category != 10 &&
//                                     accountLoading
//                                   }
//                                   value={i.value}
//                                   onClick={({ target: { name, value } }) => {
//                                     handleOnChange(name, value);
//                                     setAccountSupplierType(value);
//                                   }}
//                                 >
//                                   {i.label}
//                                 </button>
//                               ))}
//                             </div>
//                           </div>
//                           {form?.account_sub_category != "10" && (
//                             <>
//                               {!accountLoading ? <div className="singleDiv">
//                                 <CustomSelect
//                                   label="Select Account"
//                                   name="account_id"
//                                   onSelect={(data) => {
//                                     handleOnChange("account_id", data.value);
//                                   }}
//                                   value={
//                                     form?.account_id
//                                       ? accountList?.find(
//                                         (i) => i.value == form?.account_id
//                                       ) || { label: "", value: "" }
//                                       : { label: "", value: "" }
//                                   }
//                                   options={accountList}
//                                   focus={!!formError?.account_id}
//                                   error={formError.account_id}
//                                 />
//                               </div> : <SkeletonInput isLoading={accountLoading} />}
//                             </>
//                           )}

//                           {form?.account_sub_category == 2 && (
//                             <div>
//                               <input
//                                 type="checkbox"
//                                 id="vehicle1"
//                                 name="supplier_account"
//                                 checked={isCheck}
//                                 onChange={({ target: { name, checked } }) => {
//                                   setIsCheck(checked);
//                                   if (!checked) {
//                                     setBankDetails("");
//                                   }
//                                   handleOnChange(name, checked);
//                                 }}
//                               />
//                               <label htmlFor="vehicle1">
//                                 {" "}
//                                 Select Supplier Bank Account
//                               </label>
//                               <br />
//                             </div>
//                           )}
//                           {form?.account_sub_category == 2 && (
//                             <div
//                               className="singleDiv"
//                               onClick={() => {
//                                 setModalZIndex(-1);
//                                 props?.setCanvasOpen(true);
//                               }}
//                             >
//                               <CustomSelect
//                                 label="Select Supplier Account"
//                                 options={bankAccountList}
//                                 disabled={!isCheck}
//                                 openList={false}
//                                 value={
//                                   bankDetails
//                                     ? bankAccountList?.find(
//                                       (i) => i?.value === bankDetails?._id
//                                     )
//                                     : { label: "", value: "" }
//                                 }
//                                 focus={!!formError?.vendor_bank_account}
//                                 error={formError.vendor_bank_account}
//                               />
//                             </div>
//                           )}
//                           <div className="singleDiv">
//                             <CommonInput
//                               type="text"
//                               label="Amount (₹)"
//                               placeholder="Amount"
//                               name="amount"
//                               className="__rupeeSymbol"
//                               rupeeSymbol={true}
//                               value={form.amount}
//                               onChange={({ target: { name, value } }) => {
//                                 handleOnChange(name, value);
//                               }}
//                               maxLength={10}
//                               onKeyDown={handleKeyDown}
//                               focus={!!formError?.amount}
//                               error={formError.amount}
//                             />
//                             <p className="_balSuccess">
//                               {form?.sub_category == 1
//                                 ? "Pay Supplier Claim From Balance"
//                                 : "Deduct Claim from Supplier Balance"}
//                             </p>
//                           </div>
//                         </div>
//                       </div>
//                       <div className="_othrExp_recBx">
//                         <div className="_clPay_flex">
//                           <div className="singleDiv">
//                             <div className="_attatchmentBxs">
//                               <div className="__addExp_fileBx">
//                                 <h4>Attachment</h4>
//                                 <input
//                                   type="file"
//                                   id="_fileUpload"
//                                   onChange={(e) => handleFileChange(e, "first")}
//                                   disabled={loading || form?.file?.length >= 5}
//                                 />
//                                 <label
//                                   htmlFor="_fileUpload"
//                                   className="_uploadBtn"
//                                 >
//                                   <svg
//                                     xmlns="http://www.w3.org/2000/svg"
//                                     width="20"
//                                     height="19"
//                                     viewBox="0 0 20 19"
//                                     fill="none"
//                                   >
//                                     <path
//                                       d="M5 0C6.28846 7.44425e-05 7.52716 0.497542 8.45778 1.38866C9.38839 2.27978 9.93908 3.49575 9.995 4.783L10 5V16C10.0008 16.7809 9.69698 17.5313 9.15323 18.0918C8.60948 18.6523 7.86861 18.9787 7.08804 19.0016C6.30747 19.0245 5.54873 18.7422 4.97303 18.2145C4.39733 17.6869 4.05006 16.9556 4.005 16.176L4 16V6C4.00028 5.74512 4.09788 5.49997 4.27285 5.31463C4.44782 5.1293 4.68695 5.01776 4.94139 5.00283C5.19584 4.98789 5.44638 5.07067 5.64183 5.23426C5.83729 5.39785 5.9629 5.6299 5.993 5.883L6 6V16C6.00028 16.2549 6.09788 16.5 6.27285 16.6854C6.44782 16.8707 6.68695 16.9822 6.94139 16.9972C7.19584 17.0121 7.44638 16.9293 7.64183 16.7657C7.83729 16.6021 7.9629 16.3701 7.993 16.117L8 16V5C8.00075 4.21909 7.69698 3.46867 7.15323 2.90818C6.60948 2.34769 5.86861 2.02132 5.08804 1.9984C4.30747 1.97548 3.54873 2.25784 2.97303 2.78546C2.39733 3.31309 2.05006 4.0444 2.005 4.824L2 5V14C1.99972 14.2549 1.90212 14.5 1.72715 14.6854C1.55218 14.8707 1.31305 14.9822 1.05861 14.9972C0.804163 15.0121 0.553621 14.9293 0.358167 14.7657C0.162714 14.6021 0.0371036 14.3701 0.00699997 14.117L0 14V5C0 3.67392 0.526784 2.40215 1.46447 1.46447C2.40215 0.526784 3.67392 0 5 0ZM13 14H15C15.2549 14.0003 15.5 14.0979 15.6854 14.2728C15.8707 14.4478 15.9822 14.687 15.9972 14.9414C16.0121 15.1958 15.9293 15.4464 15.7657 15.6418C15.6021 15.8373 15.3701 15.9629 15.117 15.993L15 16H13C12.7451 15.9997 12.5 15.9021 12.3146 15.7272C12.1293 15.5522 12.0178 15.313 12.0028 15.0586C11.9879 14.8042 12.0707 14.5536 12.2343 14.3582C12.3979 14.1627 12.6299 14.0371 12.883 14.007L13 14ZM13 10H18.5C18.7549 10.0003 19 10.0979 19.1854 10.2728C19.3707 10.4478 19.4822 10.687 19.4972 10.9414C19.5121 11.1958 19.4293 11.4464 19.2657 11.6418C19.1021 11.8373 18.8701 11.9629 18.617 11.993L18.5 12H13C12.7451 11.9997 12.5 11.9021 12.3146 11.7272C12.1293 11.5522 12.0178 11.313 12.0028 11.0586C11.9879 10.8042 12.0707 10.5536 12.2343 10.3582C12.3979 10.1627 12.6299 10.0371 12.883 10.007L13 10ZM13 6H18.5C18.7549 6.00028 19 6.09788 19.1854 6.27285C19.3707 6.44782 19.4822 6.68695 19.4972 6.94139C19.5121 7.19584 19.4293 7.44638 19.2657 7.64183C19.1021 7.83729 18.8701 7.9629 18.617 7.993L18.5 8H13C12.7451 7.99972 12.5 7.90212 12.3146 7.72715C12.1293 7.55218 12.0178 7.31305 12.0028 7.05861C11.9879 6.80416 12.0707 6.55362 12.2343 6.35817C12.3979 6.16271 12.6299 6.0371 12.883 6.007L13 6ZM13 2H18.5C18.7549 2.00028 19 2.09788 19.1854 2.27285C19.3707 2.44782 19.4822 2.68695 19.4972 2.94139C19.5121 3.19584 19.4293 3.44638 19.2657 3.64183C19.1021 3.83729 18.8701 3.9629 18.617 3.993L18.5 4H13C12.7451 3.99972 12.5 3.90212 12.3146 3.72715C12.1293 3.55218 12.0178 3.31305 12.0028 3.05861C11.9879 2.80416 12.0707 2.55362 12.2343 2.35817C12.3979 2.16271 12.6299 2.0371 12.883 2.007L13 2Z"
//                                       fill="#1956F6"
//                                     />
//                                   </svg>
//                                   <span>
//                                     {loading ? "Uploading" : "Add File"}
//                                   </span>
//                                 </label>
//                                 {formError?.file && (
//                                   <span className="input_drop_error">
//                                     {formError?.file}
//                                   </span>
//                                 )}
//                               </div>
//                               <div className="img_fnex_src">
//                                 {form?.file?.length > 0 &&
//                                   form?.file?.map((el, index) => {
//                                     return (
//                                       <div className="pos-relative" key={index}>
//                                         <img
//                                           className="_pdfIcon_sigxe"
//                                           src={`${masterData?.s3_url}${el?.path}`}
//                                           alt=""
//                                         />
//                                         <span className="_clDel_icon">
//                                           <IoCloseCircle
//                                             onClick={() =>
//                                               documentRemove(index)
//                                             }
//                                           />
//                                         </span>
//                                       </div>
//                                     );
//                                   })}
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                     {form?.account_sub_category == 10 && <div className="_balSuccess">
//                       <p>Supplier Balance:</p>
//                       <p>
//                         {form?.sub_category == 2
//                           ? `${totalbalance} - ${amount} = ${Number(totalbalance) - Number(amount)}`
//                           : `${totalbalance} + ${amount} = ${Number(totalbalance) + Number(amount)}`}
//                       </p>
//                     </div>}
//                   </div>
//                 </>
//               ) : (
//                 <>
//                   <div className="offcanvas-body">
//                     <div className="_lrCl_offCavBody">
//                       <div className="_lrl_otrBx selectedBxs">
//                         <div className="_lr_cnpCode">
//                           <h4 className="_lrl_cnp">
//                             {lrDetails?.consignor_id?.name}
//                           </h4>
//                           <h4 className="_lrl_code">
//                             # {lrDetails?.lr_number}
//                           </h4>
//                         </div>

//                         <div className="_lrlRout_ls">
//                           <div className="_lrHead_fsx">
//                             <h3>{lrDetails?.from_location}</h3>
//                             <p>
//                               {utils.formatDateMonth(lrDetails.invoice_date)}
//                             </p>
//                           </div>

//                           <div>
//                             <svg
//                               xmlns="http://www.w3.org/2000/svg"
//                               width="136"
//                               height="29"
//                               viewBox="0 0 136 29"
//                               fill="none"
//                             >
//                               <path d="M0 15L51 15" stroke="#DFE8FF" />
//                               <path d="M85 15L136 15" stroke="#DFE8FF" />
//                               <circle
//                                 cx="67.5"
//                                 cy="14.5"
//                                 r="14.5"
//                                 fill="#DFE8FF"
//                               />
//                               <path
//                                 d="M63.5 6C62.837 6 62.2011 6.26339 61.7322 6.73223C61.2634 7.20107 61 7.83696 61 8.5V17.5C61 18.318 61.393 19.044 62 19.5V21.5C62 21.6326 62.0527 21.7598 62.1464 21.8536C62.2402 21.9473 62.3674 22 62.5 22H64.5C64.6326 22 64.7598 21.9473 64.8536 21.8536C64.9473 21.7598 65 21.6326 65 21.5V20H71V21.5C71 21.6326 71.0527 21.7598 71.1464 21.8536C71.2402 21.9473 71.3674 22 71.5 22H73.5C73.6326 22 73.7598 21.9473 73.8536 21.8536C73.9473 21.7598 74 21.6326 74 21.5V19.5C74.607 19.044 75 18.318 75 17.5V8.5C75 7.83696 74.7366 7.20107 74.2678 6.73223C73.7989 6.26339 73.163 6 72.5 6H63.5ZM63 9C63 8.73478 63.1054 8.48043 63.2929 8.29289C63.4804 8.10536 63.7348 8 64 8H72C72.2652 8 72.5196 8.10536 72.7071 8.29289C72.8946 8.48043 73 8.73478 73 9V12.9C73 13.525 72.438 13.992 71.83 13.894C70.925 13.747 69.208 13.5 68 13.5C66.792 13.5 65.075 13.747 64.17 13.894C64.0259 13.9175 63.8784 13.9093 63.7378 13.8702C63.5971 13.8311 63.4666 13.7618 63.3554 13.6673C63.2441 13.5728 63.1547 13.4552 63.0933 13.3227C63.032 13.1902 63.0001 13.046 63 12.9V9ZM64 18C63.7348 18 63.4804 17.8946 63.2929 17.7071C63.1054 17.5196 63 17.2652 63 17C63 16.7348 63.1054 16.4804 63.2929 16.2929C63.4804 16.1054 63.7348 16 64 16C64.2652 16 64.5196 16.1054 64.7071 16.2929C64.8946 16.4804 65 16.7348 65 17C65 17.2652 64.8946 17.5196 64.7071 17.7071C64.5196 17.8946 64.2652 18 64 18ZM72 18C71.7348 18 71.4804 17.8946 71.2929 17.7071C71.1054 17.5196 71 17.2652 71 17C71 16.7348 71.1054 16.4804 71.2929 16.2929C71.4804 16.1054 71.7348 16 72 16C72.2652 16 72.5196 16.1054 72.7071 16.2929C72.8946 16.4804 73 16.7348 73 17C73 17.2652 72.8946 17.5196 72.7071 17.7071C72.5196 17.8946 72.2652 18 72 18ZM67 16H69C69.2652 16 69.5196 16.1054 69.7071 16.2929C69.8946 16.4804 70 16.7348 70 17C70 17.2652 69.8946 17.5196 69.7071 17.7071C69.5196 17.8946 69.2652 18 69 18H67C66.7348 18 66.4804 17.8946 66.2929 17.7071C66.1054 17.5196 66 17.2652 66 17C66 16.7348 66.1054 16.4804 66.2929 16.2929C66.4804 16.1054 66.7348 16 67 16Z"
//                                 fill="#1450EC"
//                               />
//                             </svg>
//                           </div>

//                           <div className="_lrHead_fsx _lrs_rSide">
//                             <h3>{lrDetails?.to_location}</h3>
//                           </div>
//                         </div>

//                         <div className="_lr_cnpCode">
//                           <h4 className="_lrl_code">
//                             INV- {lrDetails?.invoice_number}
//                           </h4>

//                           <p className="_lrl_stats">
//                             <span>
//                               <svg
//                                 xmlns="http://www.w3.org/2000/svg"
//                                 width="12"
//                                 height="11"
//                                 viewBox="0 0 12 11"
//                                 fill="none"
//                               >
//                                 <ellipse
//                                   cx="5.54354"
//                                   cy="5.5"
//                                   rx="5.54354"
//                                   ry="5.5"
//                                   fill="#22A57A"
//                                 />
//                               </svg>
//                             </span>{" "}
//                             In Transit{" "}
//                           </p>
//                         </div>
//                       </div>

//                       <div>
//                         <div className="checkBx_lv">
//                           <div>
//                             <span className="_tdsLabel">
//                               {form.sub_category == 1
//                                 ? "Claim from Party"
//                                 : "Pay to Party"}
//                             </span>
//                             <div className="form-check form-switch">
//                               <input
//                                 className="form-check-input"
//                                 type="checkbox"
//                                 id="flexSwitchCheckDefault"
//                                 name="checkForParty"
//                                 checked={form?.checkForParty}
//                                 onChange={({ target: { name, checked } }) =>
//                                   handleOnChange(name, checked)
//                                 }
//                               />
//                               <label
//                                 className="form-check-label"
//                                 htmlFor="flexSwitchCheckDefault"
//                               >
//                                 {form?.checkForParty ? "Yes" : "No"}
//                               </label>
//                             </div>
//                           </div>
//                         </div>
//                       </div>

//                       {form?.checkForParty && (
//                         <div className="_clPay_flex">
//                           <div className="singleDiv">
//                             <CommonInput
//                               type="text"
//                               label="Amount (₹)"
//                               placeholder="Amount (₹)"
//                               name="party_amount"
//                               value={form.party_amount}
//                               onChange={({ target: { name, value } }) => {
//                                 handleOnChange(name, value);
//                               }}
//                               maxLength={10}
//                               onKeyDown={handleKeyDown}
//                               focus={!!formError?.party_amount}
//                               error={formError.party_amount}
//                             />
//                           </div>

//                           <div className="singleDiv">
//                             <CityDropdownForTrip
//                               label={categoryLabel}
//                               placeholder={categoryPlace}
//                               fetchData={fetchExpenseCategoriesWithSubCategory}
//                               pageSize={DROPDOWN_PAGE_SIZE}
//                               onChange={(data) => {
//                                 handleOnChange("party_expense_category", data.value);
//                                 setSelectedPartCategory(data);
//                               }}
//                               selectedItem={selectedPartCategory}
//                               error={formError?.party_expense_category}
//                               errorMessage={formError?.party_expense_category}
//                               focus={!!formError?.party_expense_category}
//                             />
//                           </div>

//                           <div className="singleDiv">
//                             <CommonDatePicker
//                               name="date"
//                               label="Transaction Date"
//                               startDate={form?.party_txn_date}
//                               setStartDate={(data) => {
//                                 handleOnChange("party_txn_date", data);
//                               }}
//                               error={formError?.party_txn_date}
//                               focus={!!formError?.party_txn_date}
//                             />
//                           </div>

//                           <div className="singleDiv">
//                             <CommonInput
//                               type="text"
//                               label="Description"
//                               placeholder="Description"
//                               name="party_description"
//                               value={form?.party_description}
//                               onChange={({ target: { name, value } }) =>
//                                 handleOnChange(name, value)
//                               }
//                               focus={!!formError?.party_description}
//                               error={formError.party_description}
//                             />
//                           </div>

//                           <div className="singleDiv">
//                             <div className="_payMode_hed">
//                               <h4>
//                                 {form.sub_category == 1
//                                   ? "Payment Mode from Party"
//                                   : "Receive Mode to Party"}
//                               </h4>
//                               {claimAccount.map((i) => (
//                                 <button
//                                   key={i?.value}
//                                   className={`_baseSpan ${i?.value == form?.party_account_sub_category
//                                     ? ""
//                                     : "_bspDisable"
//                                     }`}
//                                   name="party_account_sub_category"
//                                   disabled={
//                                     form?.party_account_sub_category != 10 &&
//                                     accountLoading
//                                   }
//                                   value={i.value}
//                                   onClick={({ target: { name, value } }) => {
//                                     handleOnChange(name, value);
//                                     setAccountPartyType(value);
//                                   }}
//                                 >
//                                   {i.label}
//                                 </button>
//                               ))}
//                             </div>
//                           </div>

//                           {form?.party_account_sub_category != 10 && (
//                             <div className="singleDiv">
//                               <CustomSelect
//                                 label="Select Account"
//                                 name="party_account_id"
//                                 onSelect={(data) =>
//                                   handleOnChange("party_account_id", data.value)
//                                 }
//                                 value={
//                                   form?.party_account_id
//                                     ? accountList2?.find(
//                                       (i) => i.value == form?.party_account_id
//                                     ) || { label: "", value: "" }
//                                     : { label: "", value: "" }
//                                 }
//                                 options={accountList2}
//                                 focus={!!formError?.party_account_id}
//                                 error={formError.party_account_id}
//                               />
//                             </div>
//                           )}

//                           <div className="singleDiv">
//                             <div className="_attatchmentBxs">
//                               <h4>Attachment</h4>

//                               <div className="_athBxs">
//                                 <input
//                                   type="file"
//                                   id="_fileUpload"
//                                   onChange={(e) =>
//                                     handleFileChange(e, "second")
//                                   }
//                                   disabled={loading || form?.party_file?.length >= 5}
//                                 />
//                                 <label
//                                   htmlFor="_fileUpload"
//                                   className="_uploadBtn"
//                                 >
//                                   <svg
//                                     xmlns="http://www.w3.org/2000/svg"
//                                     width="20"
//                                     height="19"
//                                     viewBox="0 0 20 19"
//                                     fill="none"
//                                   >
//                                     <path
//                                       d="M5 0C6.28846 7.44425e-05 7.52716 0.497542 8.45778 1.38866C9.38839 2.27978 9.93908 3.49575 9.995 4.783L10 5V16C10.0008 16.7809 9.69698 17.5313 9.15323 18.0918C8.60948 18.6523 7.86861 18.9787 7.08804 19.0016C6.30747 19.0245 5.54873 18.7422 4.97303 18.2145C4.39733 17.6869 4.05006 16.9556 4.005 16.176L4 16V6C4.00028 5.74512 4.09788 5.49997 4.27285 5.31463C4.44782 5.1293 4.68695 5.01776 4.94139 5.00283C5.19584 4.98789 5.44638 5.07067 5.64183 5.23426C5.83729 5.39785 5.9629 5.6299 5.993 5.883L6 6V16C6.00028 16.2549 6.09788 16.5 6.27285 16.6854C6.44782 16.8707 6.68695 16.9822 6.94139 16.9972C7.19584 17.0121 7.44638 16.9293 7.64183 16.7657C7.83729 16.6021 7.9629 16.3701 7.993 16.117L8 16V5C8.00075 4.21909 7.69698 3.46867 7.15323 2.90818C6.60948 2.34769 5.86861 2.02132 5.08804 1.9984C4.30747 1.97548 3.54873 2.25784 2.97303 2.78546C2.39733 3.31309 2.05006 4.0444 2.005 4.824L2 5V14C1.99972 14.2549 1.90212 14.5 1.72715 14.6854C1.55218 14.8707 1.31305 14.9822 1.05861 14.9972C0.804163 15.0121 0.553621 14.9293 0.358167 14.7657C0.162714 14.6021 0.0371036 14.3701 0.00699997 14.117L0 14V5C0 3.67392 0.526784 2.40215 1.46447 1.46447C2.40215 0.526784 3.67392 0 5 0ZM13 14H15C15.2549 14.0003 15.5 14.0979 15.6854 14.2728C15.8707 14.4478 15.9822 14.687 15.9972 14.9414C16.0121 15.1958 15.9293 15.4464 15.7657 15.6418C15.6021 15.8373 15.3701 15.9629 15.117 15.993L15 16H13C12.7451 15.9997 12.5 15.9021 12.3146 15.7272C12.1293 15.5522 12.0178 15.313 12.0028 15.0586C11.9879 14.8042 12.0707 14.5536 12.2343 14.3582C12.3979 14.1627 12.6299 14.0371 12.883 14.007L13 14ZM13 10H18.5C18.7549 10.0003 19 10.0979 19.1854 10.2728C19.3707 10.4478 19.4822 10.687 19.4972 10.9414C19.5121 11.1958 19.4293 11.4464 19.2657 11.6418C19.1021 11.8373 18.8701 11.9629 18.617 11.993L18.5 12H13C12.7451 11.9997 12.5 11.9021 12.3146 11.7272C12.1293 11.5522 12.0178 11.313 12.0028 11.0586C11.9879 10.8042 12.0707 10.5536 12.2343 10.3582C12.3979 10.1627 12.6299 10.0371 12.883 10.007L13 10ZM13 6H18.5C18.7549 6.00028 19 6.09788 19.1854 6.27285C19.3707 6.44782 19.4822 6.68695 19.4972 6.94139C19.5121 7.19584 19.4293 7.44638 19.2657 7.64183C19.1021 7.83729 18.8701 7.9629 18.617 7.993L18.5 8H13C12.7451 7.99972 12.5 7.90212 12.3146 7.72715C12.1293 7.55218 12.0178 7.31305 12.0028 7.05861C11.9879 6.80416 12.0707 6.55362 12.2343 6.35817C12.3979 6.16271 12.6299 6.0371 12.883 6.007L13 6ZM13 2H18.5C18.7549 2.00028 19 2.09788 19.1854 2.27285C19.3707 2.44782 19.4822 2.68695 19.4972 2.94139C19.5121 3.19584 19.4293 3.44638 19.2657 3.64183C19.1021 3.83729 18.8701 3.9629 18.617 3.993L18.5 4H13C12.7451 3.99972 12.5 3.90212 12.3146 3.72715C12.1293 3.55218 12.0178 3.31305 12.0028 3.05861C11.9879 2.80416 12.0707 2.55362 12.2343 2.35817C12.3979 2.16271 12.6299 2.0371 12.883 2.007L13 2Z"
//                                       fill="#1956F6"
//                                     />
//                                   </svg>
//                                   <span>
//                                     {loading ? "Uploading" : "Add File"}
//                                   </span>
//                                 </label>
//                                 {formError?.party_file && (
//                                   <span className="input_drop_error">
//                                     {formError?.party_file}
//                                   </span>
//                                 )}
//                               </div>
//                               <div className="img_fnex_src">
//                                 {form?.party_file?.length > 0 &&
//                                   form?.party_file?.map((el, index) => {
//                                     return (
//                                       <div className="pos-relative" key={index}>
//                                         <img
//                                           className="_pdfIcon_sigxe"
//                                           src={`${masterData?.s3_url}${el?.path}`}
//                                           alt=""
//                                         />
//                                         <span className="_clDel_icon">
//                                           <IoCloseCircle
//                                             onClick={() =>
//                                               partyDocumentRemove(index)
//                                             }
//                                           />
//                                         </span>
//                                       </div>
//                                     );
//                                   })}
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       )}
//                     </div>
//                   </div>

//                   <div className="_balSuccess">
//                     <p>Balance</p>

//                     <p>
//                       {(
//                         props?.transactionList?.freight_summary?.freight_summary
//                           ?.balance - form?.amount
//                       ).toFixed(2)}
//                     </p>
//                   </div>
//                 </>
//               )}
//               <div className="offcanvas-footer">
//                 {userSettingPermission?.trip_payment_approval == 1 && <LoaderButton
//                   onClick={() => onSubmitClaim(1)}
//                   isLoadingText="Processing..."
//                   className="_submitOn_modal custom-button"
//                   loaderClass="custom-spinner"
//                   disabled={isloadingSend}
//                   isLoading={isloadingSend}
//                 >
//                   Send for Approval
//                 </LoaderButton>}
//                 <LoaderButton
//                   onClick={() => onSubmitClaim(0)}
//                   isLoading={isLoadding}
//                   isLoadingText="Processing..."
//                   className="_submitOn_modal"
//                   disabled={isLoadding}
//                 >
//                   {form?.sub_category === 2
//                     ? "Charge Supplier"
//                     : "Pay Supplier"}
//                 </LoaderButton>
//               </div>
//             </>
//           </>
//         )}
//       </div>
//       <div className={isOpen ? "offBack_drop" : ""}></div>
//       {isOpenFuelModal && <AddEditModal
//         {...openZoneModal}
//       />}
//     </div>
//   );
// };

// export default ClaimCanvas;


import {
  addExpenseApi,
  getCommonExpenseApi,
  getUserAccountList,
  handleKeyDown,
  uploadFiles,
} from "_services";
import {
  CommonDatePicker,
  CommonInput,
  CrossButton,
  CustomSelect,
  LoaderButton,
  SkeletonInput,
} from "components";
import { Images } from "constants";
import { UserContext } from "context";
import { addTransationConsignor, addTransationFreight } from "features";
import { errorSchema, utils } from "helper";
import AddEditModal from "modals/AddEditModal";
import React, { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { IoCloseCircle } from "react-icons/io5";
import { useDispatch } from "react-redux";
import { getAllPermissions } from "utils/permissionHelper";
import StorageService from "utils/StorageServices/StorageServices";

const ClaimCanvas = (props) => {
  const {
    lrDetails,
    tripId,
    isOpen,
    closeModal,
    callBackFreight,
    transactionList,
  } = props;

  const initiFrom = {
    submitType: 1,
    category: "",
    sub_category: "",
    expense_category: "",
    amount: "",
    txn_date: new Date(),
    account_category: "",
    account_sub_category: "",
    account_id: "",
    description: "",
    vendor_type: "",
    vendor_account: "",
    lr_id: "",
    trip_id: props?.tripId,
    branch_id: "",
    company_id: StorageService.getCompanyId(),
    vehicle_id: "",
    file: [],
    checkForParty: false,
    party_expense_category: "",
    party_amount: "",
    party_txn_date: new Date(),
    party_account_sub_category: "",
    party_account_id: "",
    party_description: "",
    supplier_account: false,
    vendor_bank_account: "",
    party_file: [],
    no_of_days: 0,
    days_rate: 0,
    perc_of_revenue: 0
  };

  const {
    masterData,
    globTripDetails,
    bankDetails,
    setModalZIndex,
    modalZIndex,
    setBankDetails,
    userSettingPermission,
    allMenu
  } = useContext(UserContext);
  const dispatch = useDispatch();
  const [form, setForm] = useState(initiFrom);
  const [formError, setFormError] = useState("");
  const [claimTypeList, setClaimTypeList] = useState([]);
  const [claimAccount, setClaimAccount] = useState([]);
  const [accountPartyType, setAccountPartyType] = useState("");
  const [accountSupplierType, setAccountSupplierType] = useState("");
  const [expenseList, setExpenseList] = useState([]);
  const [accountList, setAccountList] = useState([]);
  const [commExpenseList, setCommExpenseList] = useState([]);
  const [accountList2, setAccountList2] = useState([]);
  const [isLoadding, setIsLoadding] = useState(false);
  const [isCheck, setIsCheck] = useState(bankDetails ? true : false);
  const [bankAccountList, setBankAccountList] = useState([]);
  const [accountLoading, setAccountLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reciptList, setReciptList] = useState([]);
  const [expenseDetails, setExpenseDetails] = useState("");
  const [categoryDetails, setCategoryDetails] = useState({});
  const [isloadingSend, setIsloadingSend] = useState(false);
  const balance = props?.transactionList?.freight_summary?.balance;
  const [isOpenFuelModal, setIsOpenFuelModal] = useState(false)
  const hasLinkCharofAccountPermission = getAllPermissions("/accounting/chartofaccounts", allMenu, 'link');


  useEffect(() => {
    if (form?.sub_category) {
      getCommonExpense(form?.sub_category);
      handleOnChange("expense_category", "");
    }
  }, [form?.sub_category]);

  useEffect(() => {
    getMasterFreight();
  }, [masterData]);

  useEffect(() => {
    if (accountSupplierType) {
      setForm({ ...form, account_id: "" });
    }
  }, [accountSupplierType]);

  useEffect(() => {
    if (accountPartyType) {
      setForm({ ...form, party_account_id: "" });
    }
  }, [accountPartyType]);

  useEffect(() => {
    if (form?.account_sub_category != 10 && form?.account_category) {
      if (form?.account_id == "") {
        setIsCheck(false);
        getAccountListHandler();
      }
    }
  }, [form?.account_sub_category, form?.account_category, form?.account_id]);

  useEffect(() => {
    if (
      form?.party_account_sub_category != 10 &&
      form?.account_category &&
      accountList?.length
    ) {
      getAccountListHandler2();
      if (form?.party_account_id == "") {
      }
    }
  }, [
    form?.party_account_sub_category,
    form?.account_category,
    accountList,
    form?.party_account_id,
  ]);

  useEffect(() => {
    if (props?.accountList?.length > 0) {
      let list = props?.accountList?.map((i) => {
        return {
          ...i,
          label: i?.bank_name || i?.account_name || i?.upi_id,
          value: i?._id,
        };
      });
      setBankAccountList(list);
    }
  }, [props?.accountList]);

  useEffect(() => {
    if (bankDetails) {
      handleOnChange("vendor_bank_account", bankDetails?._id);
    }
  }, [bankDetails]);

  useEffect(() => {
    if (!isCheck) {
      setBankDetails("");
      if (form?.vendor_account) {
        setForm({ ...form, vendor_account: "" });
      }

    } else {
      setForm({ ...form, vendor_account: bankAccountList[0]?._id });
      setBankDetails(bankAccountList[0])
    }
  }, [isCheck]);

  const getMasterFreight = async () => {
    try {
      const details = masterData?.supplier_claims?.sub_type?.map((item) => {
        return {
          label: item?.name,
          value: item?.id,
          id: item?.id,
          status: item?.status,
          category_id: masterData?.supplier_claims?.id,
          type: masterData?.supplier_claims?.type,
        };
      });

      const final = details?.reverse();
      const detailsAccount =
        masterData?.market_account_category?.sub_category?.map((item) => {
          return {
            label: item?.name,
            value: item?.id,
            category_id: masterData?.market_account_category?.id,
          };
        });

      const reorderedItems = detailsAccount.filter(
        (item) => item.label !== "Balance"
      );
      const cashItem = detailsAccount.find((item) => item.label === "Balance");
      // let list = [cashItem, ...reorderedItems];
      let list = [cashItem];


      if (list.length && details) {
        setForm({
          ...form,
          trip_id: tripId,
          category: final[0]?.category_id,
          sub_category: final[0]?.value,
          account_category: list[0]?.category_id,
          account_sub_category: list[0]?.value,
          party_account_sub_category: list[0]?.value,
        });

        setClaimTypeList(final);
        setClaimAccount(list);
      }
      // }
    } catch { }
  };

  const getCommonExpense = async (expense) => {
    try {
      const payload = {
        company_id: StorageService.getCompanyId(),
        category_id: expense == 1 ? 5 : 4,
        sub_category_id: expense == 1 ? 4 : 3,
      };
      const res = await getCommonExpenseApi(payload);
      if (res?.responseCode === 200) {
        const details = res?.data?.categories?.map((item) => {
          return {
            ...item,
            label: item?.name,
            value: item?._id,
          };
        });
        setCommExpenseList(details);
        setExpenseDetails(res?.data);
      } else {
      }
    } catch (error) { }
  };

  const getAccountListHandler = async () => {
    setAccountLoading(true);
    try {
      const res = await getUserAccountList({
        company_id: StorageService?.getCompanyId(),
        category_id: parseInt(form?.account_category),
        sub_category_id: parseInt(form?.account_sub_category),
        account_id: "",
      });


      if (res?.responseCode === 200) {
        setAccountLoading(false);
        const details = res?.data?.account_list?.map((item) => ({
          ...item,
          label: item?.name,
          value: item?._id,
        }));

        setAccountList(details);
        if (details.length > 0) {
          // setForm({ ...form, account_id: details[0].value });
          handleOnChange("account_id", details[0].value);
        }
      } else {
        setAccountLoading(false)
        setAccountList([]);

      }
    } catch (error) {
      setAccountLoading(false)
      setAccountList([]);
    } finally {
      setAccountLoading(false)

    }
  };

  const getAccountListHandler2 = async () => {
    setAccountLoading(true);
    try {
      const res = await getUserAccountList({
        company_id: StorageService?.getCompanyId(),
        category_id: parseInt(form?.account_category),
        sub_category_id: parseInt(form?.party_account_sub_category),
        account_id: "",
      });

      if (res?.responseCode === 200) {
        setAccountLoading(false);
        const details = res?.data?.account_list?.map((item) => ({
          ...item,
          label: item?.name,
          value: item?._id,
        }));
        setAccountList2(details);
        if (details.length > 0) {
          handleOnChange("party_account_id", details[0].value);
          // setForm({ ...form, party_account_id: details[0].value });
        }
      } else {
        setAccountLoading(false);
      }
    } catch (error) {
    } finally {
      setAccountLoading(false);
    }
  };

  const handleOnChange = async (name, value) => {
    const stateObj = {
      ...form,
      [name]: value,
    };

    if (name === "expense_category") {
      stateObj.party_expense_category = value;
    }
    if (name === "amount") {
      stateObj.party_amount = value;
    }
    if (name === "description") {
      stateObj.party_description = value;
    }
    if (name === "txn_date") {
      stateObj.party_txn_date = value;
    }
    if (name === "account_sub_category") {
      stateObj.party_account_sub_category = value;
    }
    if (name === "account_id") {
      stateObj.party_account_id = value;
    }
    if (name === "supplier_account") {
      stateObj.vendor_bank_account = "";
    }
    setForm(stateObj);

    if (!!formError) {
      const validationResult = await utils.checkFormError(
        { ...stateObj, balance: balance, categoryDetails: categoryDetails?.calculation_type, },
        errorSchema.addClaimFullSchema
      );

      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };


  const onSubmitClaim = async (approve) => {
    const validationResult = await utils.checkFormError(
      {
        ...form,
        balance: balance,
        categoryDetails: categoryDetails?.calculation_type, // ✅ important for conditional validation
      },
      errorSchema.addClaimFullSchema
    );

    const payloadforSupplier = {
      type: form?.category ? parseInt(form?.category) : "",
      sub_type: form?.sub_category ? parseInt(form?.sub_category) : "",
      expense_category: form?.expense_category,
      // category_id: expenseDetails?.category_id,
      // sub_category_id: expenseDetails?.sub_category_id,
      amount: (form?.amount).toString(),
      date: utils.convertToISO(form?.txn_date, true),
      account_category: form?.account_category
        ? parseInt(form?.account_category)
        : "",
      account_sub_category: form?.account_sub_category
        ? parseInt(form?.account_sub_category)
        : "",
      account_id: form?.account_id ? form?.account_id : "",
      description: form?.description,
      // vendor_type: globTripDetails?.vehicle_ownership == 2 ? 1 : "",
      // vendor_id: globTripDetails?.supplier_id?._id,
      vendor_bank_account: bankDetails ? bankDetails?._id : "",
      lr_id: lrDetails?._id,
      trip_id: props.tripId,
      branch_id: globTripDetails?.branch_id?._id,
      company_id: form?.company_id,
      vehicle_id: globTripDetails?.vehicle_id?._id,
      file: form?.file,
      is_approval: approve,
      no_of_days: form?.no_of_days,
      days_rate: form?.days_rate,
      perc_of_revenue: form?.perc_of_revenue
    };

    const payloadforConsignor = {
      type: form?.category ? parseInt(form?.category) : "",
      sub_type: form?.sub_category ? parseInt(form?.sub_category) : "",
      expense_category: form?.party_expense_category,
      // category_id: expenseDetails?.category_id,
      // sub_category_id: expenseDetails?.category_id,
      amount: form?.party_amount,
      date: utils.convertToISO(form?.txn_date, true),
      account_category: form?.account_category
        ? parseInt(form?.account_category)
        : "",
      account_sub_category: form?.party_account_sub_category
        ? parseInt(form?.party_account_sub_category)
        : "",
      account_id: form?.party_account_id
        ? parseInt(form?.party_account_id)
        : "",
      description: form?.party_description,
      // vendor_type: globTripDetails?.vehicle_ownership == 2 ? 2 : "",
      // vendor_id: lrDetails?.consignor_id?._id,
      vendor_bank_account: "",
      lr_id: lrDetails?._id,
      trip_id: props.tripId,
      branch_id: globTripDetails?.branch_id?._id,
      company_id: form?.company_id,
      vehicle_id: globTripDetails?.vehicle_id?._id,
      file: form?.party_file,
      is_approval: approve,
      no_of_days: (form?.no_of_days).toString(),
      days_rate: (form?.days_rate).toString(),
      perc_of_revenue: (form?.perc_of_revenue).toString()
    };

    setFormError(validationResult);

    if (validationResult === true) {
      approve == 0 ? setIsLoadding(true) : setIsloadingSend(true);
      try {
        if (form?.checkForParty) {
          const resForSupplier = await dispatch(
            addTransationFreight(payloadforSupplier)
          );
          const resForParty = await dispatch(
            addTransationConsignor(payloadforConsignor)
          );

          if (
            resForSupplier?.payload?.responseCode === 200 &&
            resForParty?.payload?.responseCode === 200
          ) {
            setIsLoadding(false);
            setIsloadingSend(false);
            closeModal();
            callBackFreight();
            setBankDetails("");
          } else {
            setIsLoadding(false);
            setIsloadingSend(false);
          }
        } else {
          const resForSupplier = await dispatch(
            addTransationFreight(payloadforSupplier)
          );

          if (resForSupplier?.payload?.responseCode === 200) {
            setIsLoadding(false);
            setIsloadingSend(false);
            closeModal();
            callBackFreight();
            setBankDetails("");
          } else {
            setIsLoadding(false);
            setIsloadingSend(false);
          }
        }
      } catch {
        setIsLoadding(false);
        setIsloadingSend(false);
      }
    } else {
      setFormError(validationResult);
      setIsLoadding(false);
      setIsloadingSend(false);
    }
  };

  const continueHnadle = async () => {
    const validationResult = await utils.checkFormError(
      { ...form, balance: balance },
      errorSchema.addClaimSchema
    );

    if (validationResult === true) {
      setForm({ ...form, submitType: 2 });
    } else {
      setFormError(validationResult);
    }
  };

  const validateInput = (value) => {
    const number = parseFloat(value);
    return number <= transactionList?.freight_summary?.freight_summary?.balance;
  };

  const backButton = () => {
    setForm({ ...form, submitType: 1 });
  };

  const handleFileChange = async (e, type) => {
    if (
      e?.target?.files[0]?.type === "image/gif" ||
      e?.target?.files[0]?.type === "image/jpeg" ||
      e?.target?.files[0]?.type === "image/png"
    ) {
      setLoading(true);
      try {
        const formData = new FormData();
        formData.append("file", e?.target?.files[0]);
        const res = await uploadFiles(formData);
        if (res?.responseCode === 200) {
          var fileArray = [];

          if (type == "first") {
            fileArray.push(...form?.file, {
              filename: res?.data?.filename,
              path: res?.data?.path,
            });
            handleOnChange("file", fileArray);
          } else {
            fileArray.push(...form?.party_file, {
              filename: res?.data?.filename,
              path: res?.data?.path,
            });
            handleOnChange("party_file", fileArray);
          }

          // setFormValue((s) => ({ ...s, file: fileArray }));
          setLoading(false);
          toast.success("Document added ");
        }
      } catch (error) {
        setLoading(false);
      }
    } else {
      toast.error("Invalid file, choose jpeg/png images");
    }
  };

  const documentRemove = (index) => {
    const newFromIput = [...form?.file];

    newFromIput.splice(index, 1);

    setForm({ ...form, file: newFromIput });
  };

  const partyDocumentRemove = (index) => {
    const newFromIput = [...form?.party_file];

    newFromIput.splice(index, 1);

    setForm({ ...form, party_file: newFromIput });
  };

  const isExpense = form?.sub_category == 1;
  const categoryLabel = isExpense ? "Expense Category" : "Receipt Category";
  const categoryPlace = isExpense
    ? "Select Expense Category"
    : " Select Receipt Category";
  const categoryOptions = commExpenseList || [{ label: "", value: "" }];
  const selectedCategory = commExpenseList?.find(
    (i) => i.value === form?.expense_category
  );

  const selectedPartCategory = commExpenseList?.find(
    (i) => i.value === form?.party_expense_category
  );

  const totalbalance = props?.transactionList?.freight_summary?.balance || 0;
  const amount = form?.amount || 0;
  const result = balance - amount;

  const callBackApi = (data) => {
    getCommonExpense(form?.sub_category);
    handleOnChange("expense_category", data?.category?._id)
    callBackFreight()
  };

  const addExpenseHandle = (data) => {
    setIsOpenFuelModal(true);
  };

  let openZoneModal = {
    isOpen: isOpenFuelModal,
    closeModal: (e) => setIsOpenFuelModal(false),
    // nextModal: (e) => submitUpdateData(e),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: form?.sub_category == 1 ? 'Add Trip Expenses' : 'Add Trip Receipt',
    submitTitle: form?.sub_category == 1 ? 'Add Trip Expenses' : 'Add Trip Receipt',
    footerPart: true,
    label: form?.sub_category == 1 ? 'Expenses Name' : 'Receipt Name',
    placeholder: form?.sub_category == 1 ? 'Enter Expenses Name' : 'Enter Receipt Name',
    ApiPoint: addExpenseApi,
    callBackApi: callBackApi,
    payloadData: {
      category_id: form?.sub_category == 1 == 1 ? 5 : 4,
      sub_category_id: form?.sub_category == 1 == 1 ? 4 : 3,
    },
    titleName: "Trip"
  }


  useEffect(() => {
    if (categoryDetails?.calculation_type == 2) {
      setForm((pre) => ({ ...pre, amount: pre?.no_of_days * pre?.days_rate }))
    }

    if (categoryDetails?.calculation_type == 3) {
      setForm((pre) => ({ ...pre, amount: Number(transactionList?.consignor_freight?.total_freight * Number(pre?.perc_of_revenue)) / 100 }))
    }

  }, [form?.no_of_days, form?.days_rate, form?.perc_of_revenue])

  return (
    <div>
      <div
        className={`offcanvas offcanvas-end common_offCanvas ${isOpen ? "show" : ""
          }`}
        tabIndex={-1}
        style={{
          visibility: isOpen ? "visible" : "hidden",
          display: modalZIndex ? "none" : "",
        }}
      >
        {isOpen && (
          <>
            <div className="offcanvas-header headWith_back">
              {form?.submitType !== 1 && (
                <button
                  // className="_modBack_btn"
                  // data-bs-dismiss="modal"
                  // aria-label="Close"
                  type="button"
                  onClick={backButton}
                  className="_modBack_btn"
                >
                  <img src={Images.BACKICON} alt="" />
                </button>
              )}
              <h5 className="offcanvas-title">
                {form?.sub_category == 1
                  ? "Claim Pay to Supplier"
                  : "Claim Charge form Supplier"}{" "}
              </h5>
              <CrossButton type="button" className="_switchBtn  __animEffect_btn" style={{ marginLeft: 'auto' }} onClick={closeModal}>
                <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none" >
                  <path
                    d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
                    fill="black"
                  />
                </svg>
              </CrossButton>
            </div>

            {/* {commExpenseList?.length > 0 ? ( */}
            <>
              {form.submitType === 1 ? (
                <>
                  <div className="offcanvas-body">
                    <div className="_lrCl_offCavBody __otr_expCanva">
                      <div className="_othrExp_recBx">
                        {/* <div className="_clPay_flex"></div> */}
                        <div className="_lrl_otrBx selectedBxs">
                          <div className="_lr_cnpCode">
                            <h4 className="_lrl_cnp">
                              {lrDetails?.consignor_id?.name}
                            </h4>
                            <h4 className="_lrl_code">
                              # {lrDetails?.lr_number}
                            </h4>
                          </div>

                          <div className="_lrlRout_ls">
                            <div className="_lrHead_fsx">
                              <h3>{lrDetails?.from_location}</h3>
                              <p>
                                {utils.formatDateMonth(lrDetails.invoice_date)}
                              </p>
                            </div>

                            <div>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="136"
                                height="29"
                                viewBox="0 0 136 29"
                                fill="none"
                              >
                                <path d="M0 15L51 15" stroke="#DFE8FF" />
                                <path d="M85 15L136 15" stroke="#DFE8FF" />
                                <circle
                                  cx="67.5"
                                  cy="14.5"
                                  r="14.5"
                                  fill="#DFE8FF"
                                />
                                <path
                                  d="M63.5 6C62.837 6 62.2011 6.26339 61.7322 6.73223C61.2634 7.20107 61 7.83696 61 8.5V17.5C61 18.318 61.393 19.044 62 19.5V21.5C62 21.6326 62.0527 21.7598 62.1464 21.8536C62.2402 21.9473 62.3674 22 62.5 22H64.5C64.6326 22 64.7598 21.9473 64.8536 21.8536C64.9473 21.7598 65 21.6326 65 21.5V20H71V21.5C71 21.6326 71.0527 21.7598 71.1464 21.8536C71.2402 21.9473 71.3674 22 71.5 22H73.5C73.6326 22 73.7598 21.9473 73.8536 21.8536C73.9473 21.7598 74 21.6326 74 21.5V19.5C74.607 19.044 75 18.318 75 17.5V8.5C75 7.83696 74.7366 7.20107 74.2678 6.73223C73.7989 6.26339 73.163 6 72.5 6H63.5ZM63 9C63 8.73478 63.1054 8.48043 63.2929 8.29289C63.4804 8.10536 63.7348 8 64 8H72C72.2652 8 72.5196 8.10536 72.7071 8.29289C72.8946 8.48043 73 8.73478 73 9V12.9C73 13.525 72.438 13.992 71.83 13.894C70.925 13.747 69.208 13.5 68 13.5C66.792 13.5 65.075 13.747 64.17 13.894C64.0259 13.9175 63.8784 13.9093 63.7378 13.8702C63.5971 13.8311 63.4666 13.7618 63.3554 13.6673C63.2441 13.5728 63.1547 13.4552 63.0933 13.3227C63.032 13.1902 63.0001 13.046 63 12.9V9ZM64 18C63.7348 18 63.4804 17.8946 63.2929 17.7071C63.1054 17.5196 63 17.2652 63 17C63 16.7348 63.1054 16.4804 63.2929 16.2929C63.4804 16.1054 63.7348 16 64 16C64.2652 16 64.5196 16.1054 64.7071 16.2929C64.8946 16.4804 65 16.7348 65 17C65 17.2652 64.8946 17.5196 64.7071 17.7071C64.5196 17.8946 64.2652 18 64 18ZM72 18C71.7348 18 71.4804 17.8946 71.2929 17.7071C71.1054 17.5196 71 17.2652 71 17C71 16.7348 71.1054 16.4804 71.2929 16.2929C71.4804 16.1054 71.7348 16 72 16C72.2652 16 72.5196 16.1054 72.7071 16.2929C72.8946 16.4804 73 16.7348 73 17C73 17.2652 72.8946 17.5196 72.7071 17.7071C72.5196 17.8946 72.2652 18 72 18ZM67 16H69C69.2652 16 69.5196 16.1054 69.7071 16.2929C69.8946 16.4804 70 16.7348 70 17C70 17.2652 69.8946 17.5196 69.7071 17.7071C69.5196 17.8946 69.2652 18 69 18H67C66.7348 18 66.4804 17.8946 66.2929 17.7071C66.1054 17.5196 66 17.2652 66 17C66 16.7348 66.1054 16.4804 66.2929 16.2929C66.4804 16.1054 66.7348 16 67 16Z"
                                  fill="#1450EC"
                                />
                              </svg>
                            </div>

                            <div className="_lrHead_fsx _lrs_rSide">
                              <h3>{lrDetails?.to_location}</h3>
                            </div>
                          </div>

                          <div className="_lr_cnpCode">
                            <h4 className="_lrl_code">
                              INV- {lrDetails?.invoice_number}
                            </h4>

                            <p className="_lrl_stats">
                              <span>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="12"
                                  height="11"
                                  viewBox="0 0 12 11"
                                  fill="none"
                                >
                                  <ellipse
                                    cx="5.54354"
                                    cy="5.5"
                                    rx="5.54354"
                                    ry="5.5"
                                    fill="#22A57A"
                                  />
                                </svg>
                              </span>{" "}
                              {masterData?.lr_status[lrDetails?.lr_status]
                                ? masterData?.lr_status[lrDetails?.lr_status]
                                : ""}{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="_othrExp_recBx">
                        <div className="_clPay_flex">
                          <div className="singleDiv">
                            <CommonDatePicker
                              name="date"
                              label="Transaction Date"
                              startDate={form?.txn_date}
                              setStartDate={(data) => {
                                handleOnChange("txn_date", data);
                              }}
                              error={formError?.txn_date}
                              focus={!!formError?.txn_date}
                              maxDate={new Date()}
                            />
                          </div>
                          {claimTypeList.map((i) => {
                            return (
                              <div className="_dualCheckr_bx">
                                <input
                                  className="form-check-input"
                                  id={i?.value}
                                  type="radio"
                                  name="sub_category"
                                  checked={i.value == form.sub_category}
                                  value={i.value}
                                  onChange={({ target: { name, value } }) =>
                                    handleOnChange(name, value)
                                  }
                                />
                                <label
                                  for={i?.value}
                                  className="form-check-label"
                                >
                                  {i?.label}
                                </label>
                              </div>
                            );
                          })}
                          <div className="singleDiv">
                            <CustomSelect
                              label={categoryLabel}
                              placeholder={categoryPlace}
                              options={categoryOptions}
                              onSelect={(data) => {
                                handleOnChange("expense_category", data.value)
                                setCategoryDetails(data)
                              }
                              }
                              value={selectedCategory || { label: "", value: "" }}
                              focus={!!formError?.expense_category}
                              error={formError?.expense_category}
                              isAddButton={hasLinkCharofAccountPermission?.canCreate ? true : false}
                              addButtonAction={addExpenseHandle}
                            />
                          </div>
                          <div className="singleDiv">
                            <CommonInput
                              type="textarea"
                              label="Notes"
                              placeholder="Notes"
                              name="description"
                              maxLength="500"
                              onInput={utils.maxLengthCheck}
                              value={form?.description}
                              onChange={({ target: { name, value } }) => {
                                handleOnChange(name, value);
                              }}
                              focus={!!formError?.description}
                              error={formError.description}
                            />
                          </div>
                        </div>

                      </div>
                      {/* <div>
                        <div className="checkBx_lv">

                        </div>
                      </div> */}
                      <div className="_othrExp_recBx">
                        <div className="_clPay_flex">
                          <div className="singleDiv">
                            <div className="_payMode_hed">
                              <h4>
                                {form.sub_category == 1
                                  ? "Payment Mode"
                                  : "Receipt Mode"}
                              </h4>
                              {claimAccount.map((i) => (
                                <button
                                  className={`_baseSpan ${i?.value == form?.account_sub_category
                                    ? ""
                                    : "_bspDisable"
                                    }`}
                                  name="account_sub_category"
                                  disabled={
                                    form?.account_sub_category != 10 &&
                                    accountLoading
                                  }
                                  value={i.value}
                                  onClick={({ target: { name, value } }) => {
                                    handleOnChange(name, value);
                                    setAccountSupplierType(value);
                                  }}
                                >
                                  {i.label}
                                </button>
                              ))}
                              {/* <button className="_baseSpan " >Cash</button>
                               <button className="_baseSpan _bspDisable" >Bank Transfer</button> */}
                              {/* <button className="_baseSpan _bspDisable">Balance</button> */}
                            </div>
                          </div>
                          {form?.account_sub_category != "10" && (
                            <>
                              {!accountLoading ? <div className="singleDiv">
                                <CustomSelect
                                  label="Select Account"
                                  name="account_id"
                                  onSelect={(data) => {
                                    handleOnChange("account_id", data.value);
                                  }}
                                  value={
                                    form?.account_id
                                      ? accountList?.find(
                                        (i) => i.value == form?.account_id
                                      ) || { label: "", value: "" }
                                      : { label: "", value: "" }
                                  }
                                  options={accountList}
                                  focus={!!formError?.account_id}
                                  error={formError.account_id}
                                />
                              </div> : <SkeletonInput isLoading={accountLoading} />}
                            </>

                          )}

                          {form?.account_sub_category == 2 && (
                            <div>
                              <input
                                type="checkbox"
                                id="vehicle1"
                                name="supplier_account"
                                // value="Bike"
                                checked={isCheck}
                                onChange={({ target: { name, checked } }) => {
                                  setIsCheck(checked);
                                  if (!checked) {
                                    // setForm({...form,vendor_bank_account:""})

                                    setBankDetails("");
                                  }
                                  handleOnChange(name, checked);
                                }}
                              />
                              <label for="vehicle1">
                                {" "}
                                Select Supplier Bank Account
                              </label>
                              <br />
                            </div>
                          )}
                          {form?.account_sub_category == 2 && (
                            <div
                              className="singleDiv"
                              onClick={() => {
                                // props?.setIsOpenFreight(false);
                                setModalZIndex(-1);
                                props?.setCanvasOpen(true);
                              }}
                            >
                              <CustomSelect
                                label="Select Supplier Account"
                                options={bankAccountList}
                                disabled={!isCheck}
                                openList={false}
                                value={
                                  bankDetails
                                    ? bankAccountList?.find(
                                      (i) => i?.value === bankDetails?._id
                                    )
                                    : { label: "", value: "" }
                                }
                                focus={!!formError?.vendor_bank_account}
                                error={formError.vendor_bank_account}
                              />
                            </div>
                          )}
                          {categoryDetails?.calculation_type == 2 && <div className="singleDiv">
                            <div className="flxInr">
                              <div className="halfDiv">
                                <CommonInput
                                  type="text"
                                  label="No of Days"
                                  placeholder="No of Days"
                                  name="no_of_days"
                                  onChange={({ target: { name, value } }) => {
                                    handleOnChange(name, value);
                                  }}
                                  onKeyDown={handleKeyDown}
                                  focus={!!formError?.no_of_days}
                                  error={formError.no_of_days}
                                  maxLength={3}
                                />
                              </div>

                              <div className="halfDiv">
                                <CommonInput
                                  type="text"
                                  label="Rate"
                                  placeholder="Rate"
                                  name="days_rate"
                                  onChange={({ target: { name, value } }) => {
                                    handleOnChange(name, value);
                                  }}
                                  onKeyDown={handleKeyDown}
                                  focus={!!formError?.days_rate}
                                  error={formError.days_rate}
                                  maxLength={6}
                                />
                              </div>
                            </div>
                          </div>}
                          {categoryDetails?.calculation_type === 3 && <div className="singleDiv">
                            <CommonInput
                              type="text"
                              label="% of Revenue"
                              placeholder="% of Revenue"
                              name="perc_of_revenue"
                              onChange={({ target: { name, value } }) => {
                                handleOnChange(name, value);
                              }}
                              onKeyDown={handleKeyDown}
                              focus={!!formError?.perc_of_revenue}
                              error={formError.perc_of_revenue}
                              postText="%"
                              postAddon={true}
                              maxLength={3}
                            />
                          </div>}
                          <div className="singleDiv">
                            <CommonInput
                              type="text"
                              label="Amount (₹)"
                              placeholder="Amount"
                              name="amount"
                              className="__rupeeSymbol"
                              rupeeSymbol={true}
                              value={form.amount}
                              onChange={({ target: { name, value } }) => {
                                if (/^0[0-9]/.test(value)) {
                                  value = value.replace(/^0+/, ''); // "01" → "1"
                                }

                                // Allow "0." for decimals but not "0x" where x is digit
                                if (value === "0") {
                                  handleOnChange(name, value);
                                  return;
                                }
                                handleOnChange(name, value)
                              }}
                              maxLength={10}
                              onKeyDown={handleKeyDown}
                              focus={!!formError?.amount}
                              error={formError.amount}
                              disabled={categoryDetails?.calculation_type === 2 || categoryDetails?.calculation_type === 3}
                            />
                            <p className="_balSuccess">
                              {form?.sub_category == 1
                                ? "Pay Supplier Claim From Balance"
                                : "Deduct Claim from Supplier Balance"}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="_othrExp_recBx">
                        <div className="_clPay_flex">

                          <div className="singleDiv">
                            <div className="_attatchmentBxs">
                              <div className="__addExp_fileBx">
                                <h4>Attachment</h4>
                                <input
                                  type="file"
                                  id="_fileUpload"
                                  onClick={(e) => {
                                    if (form?.file?.length >= 5) {
                                      e.preventDefault(); // stop opening file dialog
                                      toast.error("You can upload only 5 files");
                                    }
                                  }}
                                  onChange={(e) => handleFileChange(e, "first")}
                                />
                                <label
                                  htmlFor="_fileUpload"
                                  className="_uploadBtn"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="19"
                                    viewBox="0 0 20 19"
                                    fill="none"
                                  >
                                    <path
                                      d="M5 0C6.28846 7.44425e-05 7.52716 0.497542 8.45778 1.38866C9.38839 2.27978 9.93908 3.49575 9.995 4.783L10 5V16C10.0008 16.7809 9.69698 17.5313 9.15323 18.0918C8.60948 18.6523 7.86861 18.9787 7.08804 19.0016C6.30747 19.0245 5.54873 18.7422 4.97303 18.2145C4.39733 17.6869 4.05006 16.9556 4.005 16.176L4 16V6C4.00028 5.74512 4.09788 5.49997 4.27285 5.31463C4.44782 5.1293 4.68695 5.01776 4.94139 5.00283C5.19584 4.98789 5.44638 5.07067 5.64183 5.23426C5.83729 5.39785 5.9629 5.6299 5.993 5.883L6 6V16C6.00028 16.2549 6.09788 16.5 6.27285 16.6854C6.44782 16.8707 6.68695 16.9822 6.94139 16.9972C7.19584 17.0121 7.44638 16.9293 7.64183 16.7657C7.83729 16.6021 7.9629 16.3701 7.993 16.117L8 16V5C8.00075 4.21909 7.69698 3.46867 7.15323 2.90818C6.60948 2.34769 5.86861 2.02132 5.08804 1.9984C4.30747 1.97548 3.54873 2.25784 2.97303 2.78546C2.39733 3.31309 2.05006 4.0444 2.005 4.824L2 5V14C1.99972 14.2549 1.90212 14.5 1.72715 14.6854C1.55218 14.8707 1.31305 14.9822 1.05861 14.9972C0.804163 15.0121 0.553621 14.9293 0.358167 14.7657C0.162714 14.6021 0.0371036 14.3701 0.00699997 14.117L0 14V5C0 3.67392 0.526784 2.40215 1.46447 1.46447C2.40215 0.526784 3.67392 0 5 0ZM13 14H15C15.2549 14.0003 15.5 14.0979 15.6854 14.2728C15.8707 14.4478 15.9822 14.687 15.9972 14.9414C16.0121 15.1958 15.9293 15.4464 15.7657 15.6418C15.6021 15.8373 15.3701 15.9629 15.117 15.993L15 16H13C12.7451 15.9997 12.5 15.9021 12.3146 15.7272C12.1293 15.5522 12.0178 15.313 12.0028 15.0586C11.9879 14.8042 12.0707 14.5536 12.2343 14.3582C12.3979 14.1627 12.6299 14.0371 12.883 14.007L13 14ZM13 10H18.5C18.7549 10.0003 19 10.0979 19.1854 10.2728C19.3707 10.4478 19.4822 10.687 19.4972 10.9414C19.5121 11.1958 19.4293 11.4464 19.2657 11.6418C19.1021 11.8373 18.8701 11.9629 18.617 11.993L18.5 12H13C12.7451 11.9997 12.5 11.9021 12.3146 11.7272C12.1293 11.5522 12.0178 11.313 12.0028 11.0586C11.9879 10.8042 12.0707 10.5536 12.2343 10.3582C12.3979 10.1627 12.6299 10.0371 12.883 10.007L13 10ZM13 6H18.5C18.7549 6.00028 19 6.09788 19.1854 6.27285C19.3707 6.44782 19.4822 6.68695 19.4972 6.94139C19.5121 7.19584 19.4293 7.44638 19.2657 7.64183C19.1021 7.83729 18.8701 7.9629 18.617 7.993L18.5 8H13C12.7451 7.99972 12.5 7.90212 12.3146 7.72715C12.1293 7.55218 12.0178 7.31305 12.0028 7.05861C11.9879 6.80416 12.0707 6.55362 12.2343 6.35817C12.3979 6.16271 12.6299 6.0371 12.883 6.007L13 6ZM13 2H18.5C18.7549 2.00028 19 2.09788 19.1854 2.27285C19.3707 2.44782 19.4822 2.68695 19.4972 2.94139C19.5121 3.19584 19.4293 3.44638 19.2657 3.64183C19.1021 3.83729 18.8701 3.9629 18.617 3.993L18.5 4H13C12.7451 3.99972 12.5 3.90212 12.3146 3.72715C12.1293 3.55218 12.0178 3.31305 12.0028 3.05861C11.9879 2.80416 12.0707 2.55362 12.2343 2.35817C12.3979 2.16271 12.6299 2.0371 12.883 2.007L13 2Z"
                                      fill="#1956F6"
                                    />
                                  </svg>
                                  <span>
                                    {loading ? "Uploadding" : "Add File"}
                                  </span>
                                </label>
                                {formError?.file && (
                                  <span className="input_drop_error">
                                    {formError?.file}
                                  </span>
                                )}
                              </div>
                              <div className="img_fnex_src">
                                {form?.file?.length > 0 &&
                                  form?.file?.map((el, index) => {
                                    return (
                                      <>
                                        <div className="pos-relative">
                                          <img
                                            className="_pdfIcon_sigxe"
                                            src={`${masterData?.s3_url}${el?.path}`}
                                            alt=""
                                          />
                                          <span className="_clDel_icon">
                                            <IoCloseCircle
                                              onClick={() =>
                                                documentRemove(index)
                                              }
                                            />
                                          </span>
                                        </div>
                                      </>
                                    );
                                  })}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {form?.account_sub_category == 10 && <div className="_balSuccess">
                      <p>Supplier Balance:</p>

                      <p>
                        {/* {(
                          props?.transactionList?.freight_summary
                            ?.freight_summary?.balance - form?.amount
                        ).toFixed(2)} */}
                        {form?.sub_category == 2
                          ? `${totalbalance} - ${amount} = ${Number(totalbalance) - Number(amount)}`
                          : `${totalbalance} + ${amount} = ${Number(totalbalance) + Number(amount)}`}
                      </p>
                    </div>}
                  </div>
                </>
              ) : (
                <>
                  <div className="offcanvas-body">
                    <div className="_lrCl_offCavBody">
                      <div className="_lrl_otrBx selectedBxs">
                        <div className="_lr_cnpCode">
                          <h4 className="_lrl_cnp">
                            {lrDetails?.consignor_id?.name}
                          </h4>
                          <h4 className="_lrl_code">
                            # {lrDetails?.lr_number}
                          </h4>
                        </div>

                        <div className="_lrlRout_ls">
                          <div className="_lrHead_fsx">
                            <h3>{lrDetails?.from_location}</h3>
                            <p>
                              {utils.formatDateMonth(lrDetails.invoice_date)}
                            </p>
                          </div>

                          <div>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="136"
                              height="29"
                              viewBox="0 0 136 29"
                              fill="none"
                            >
                              <path d="M0 15L51 15" stroke="#DFE8FF" />
                              <path d="M85 15L136 15" stroke="#DFE8FF" />
                              <circle
                                cx="67.5"
                                cy="14.5"
                                r="14.5"
                                fill="#DFE8FF"
                              />
                              <path
                                d="M63.5 6C62.837 6 62.2011 6.26339 61.7322 6.73223C61.2634 7.20107 61 7.83696 61 8.5V17.5C61 18.318 61.393 19.044 62 19.5V21.5C62 21.6326 62.0527 21.7598 62.1464 21.8536C62.2402 21.9473 62.3674 22 62.5 22H64.5C64.6326 22 64.7598 21.9473 64.8536 21.8536C64.9473 21.7598 65 21.6326 65 21.5V20H71V21.5C71 21.6326 71.0527 21.7598 71.1464 21.8536C71.2402 21.9473 71.3674 22 71.5 22H73.5C73.6326 22 73.7598 21.9473 73.8536 21.8536C73.9473 21.7598 74 21.6326 74 21.5V19.5C74.607 19.044 75 18.318 75 17.5V8.5C75 7.83696 74.7366 7.20107 74.2678 6.73223C73.7989 6.26339 73.163 6 72.5 6H63.5ZM63 9C63 8.73478 63.1054 8.48043 63.2929 8.29289C63.4804 8.10536 63.7348 8 64 8H72C72.2652 8 72.5196 8.10536 72.7071 8.29289C72.8946 8.48043 73 8.73478 73 9V12.9C73 13.525 72.438 13.992 71.83 13.894C70.925 13.747 69.208 13.5 68 13.5C66.792 13.5 65.075 13.747 64.17 13.894C64.0259 13.9175 63.8784 13.9093 63.7378 13.8702C63.5971 13.8311 63.4666 13.7618 63.3554 13.6673C63.2441 13.5728 63.1547 13.4552 63.0933 13.3227C63.032 13.1902 63.0001 13.046 63 12.9V9ZM64 18C63.7348 18 63.4804 17.8946 63.2929 17.7071C63.1054 17.5196 63 17.2652 63 17C63 16.7348 63.1054 16.4804 63.2929 16.2929C63.4804 16.1054 63.7348 16 64 16C64.2652 16 64.5196 16.1054 64.7071 16.2929C64.8946 16.4804 65 16.7348 65 17C65 17.2652 64.8946 17.5196 64.7071 17.7071C64.5196 17.8946 64.2652 18 64 18ZM72 18C71.7348 18 71.4804 17.8946 71.2929 17.7071C71.1054 17.5196 71 17.2652 71 17C71 16.7348 71.1054 16.4804 71.2929 16.2929C71.4804 16.1054 71.7348 16 72 16C72.2652 16 72.5196 16.1054 72.7071 16.2929C72.8946 16.4804 73 16.7348 73 17C73 17.2652 72.8946 17.5196 72.7071 17.7071C72.5196 17.8946 72.2652 18 72 18ZM67 16H69C69.2652 16 69.5196 16.1054 69.7071 16.2929C69.8946 16.4804 70 16.7348 70 17C70 17.2652 69.8946 17.5196 69.7071 17.7071C69.5196 17.8946 69.2652 18 69 18H67C66.7348 18 66.4804 17.8946 66.2929 17.7071C66.1054 17.5196 66 17.2652 66 17C66 16.7348 66.1054 16.4804 66.2929 16.2929C66.4804 16.1054 66.7348 16 67 16Z"
                                fill="#1450EC"
                              />
                            </svg>
                          </div>

                          <div className="_lrHead_fsx _lrs_rSide">
                            <h3>{lrDetails?.to_location}</h3>
                          </div>
                        </div>

                        <div className="_lr_cnpCode">
                          <h4 className="_lrl_code">
                            INV- {lrDetails?.invoice_number}
                          </h4>

                          <p className="_lrl_stats">
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="11"
                                viewBox="0 0 12 11"
                                fill="none"
                              >
                                <ellipse
                                  cx="5.54354"
                                  cy="5.5"
                                  rx="5.54354"
                                  ry="5.5"
                                  fill="#22A57A"
                                />
                              </svg>
                            </span>{" "}
                            In Transit{" "}
                          </p>
                        </div>
                      </div>

                      <div>
                        <div className="checkBx_lv">
                          <div>
                            <span className="_tdsLabel">
                              {form.sub_category == 1
                                ? "Claim from Party"
                                : "Pay to Party"}
                            </span>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="flexSwitchCheckDefault"
                                name="checkForParty"
                                checked={form?.checkForParty}
                                onChange={({ target: { name, checked } }) =>
                                  handleOnChange(name, checked)
                                }
                              />
                              <label
                                className="form-check-label"
                                for="flexSwitchCheckDefault"
                              >
                                {form?.checkForParty ? "Yes" : "No"}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      {form?.checkForParty && (
                        <div className="_clPay_flex">
                          <div className="singleDiv">
                            <CommonInput
                              type="text"
                              label="Amount (₹)"
                              placeholder="Amount (₹)"
                              name="party_amount"
                              value={form.party_amount}
                              onChange={({ target: { name, value } }) => {
                                // if (validateInput(value ? value : 0)) {
                                handleOnChange(name, value);
                                // }
                              }}
                              maxLength={10}
                              onKeyDown={handleKeyDown}
                              focus={!!formError?.party_amount}
                              error={formError.party_amount}
                            />
                          </div>

                          <div className="singleDiv">
                            <CustomSelect
                              label={categoryLabel}
                              options={categoryOptions}
                              onSelect={(data) =>
                                handleOnChange(
                                  "party_expense_category",
                                  data.value
                                )
                              }
                              value={
                                selectedPartCategory || {
                                  label: "",
                                  value: "",
                                }
                              }
                              focus={!!formError?.party_expense_category}
                              error={formError?.party_expense_category}
                            />
                          </div>

                          <div className="singleDiv">
                            <CommonDatePicker
                              name="date"
                              label="Transaction Date"
                              startDate={form?.party_txn_date}
                              setStartDate={(data) => {
                                handleOnChange("party_txn_date", data);
                              }}
                              error={formError?.party_txn_date}
                              focus={!!formError?.party_txn_date}
                            />
                          </div>

                          <div className="singleDiv">
                            <CommonInput
                              type="text"
                              label="Description"
                              placeholder="Description"
                              name="party_description"
                              value={form?.party_description}
                              onChange={({ target: { name, value } }) =>
                                handleOnChange(name, value)
                              }
                              focus={!!formError?.party_description}
                              error={formError.party_description}
                            />
                          </div>

                          <div className="singleDiv">
                            <div className="_payMode_hed">
                              <h4>
                                {form.sub_category == 1
                                  ? "Payment Mode from Party"
                                  : "Receive Mode to Party"}
                              </h4>
                              {claimAccount.map((i) => (
                                <button
                                  className={`_baseSpan ${i?.value == form?.party_account_sub_category
                                    ? ""
                                    : "_bspDisable"
                                    }`}
                                  name="party_account_sub_category"
                                  disabled={
                                    form?.party_account_sub_category != 10 &&
                                    accountLoading
                                  }
                                  value={i.value}
                                  onClick={({ target: { name, value } }) => {
                                    handleOnChange(name, value);
                                    setAccountPartyType(value);
                                  }}
                                >
                                  {i.label}
                                </button>
                              ))}
                              {/* <button className="_baseSpan " >Cash</button>
                        <button className="_baseSpan _bspDisable" >Bank Transfer</button> */}
                              {/* <button className="_baseSpan _bspDisable">Balance</button> */}
                            </div>
                          </div>

                          {form?.party_account_sub_category != 10 && (
                            <div className="singleDiv">
                              <CustomSelect
                                label="Select Account"
                                name="party_account_id"
                                onSelect={(data) =>
                                  handleOnChange("party_account_id", data.value)
                                }
                                value={
                                  form?.party_account_id
                                    ? accountList2?.find(
                                      (i) => i.value == form?.party_account_id
                                    ) || { label: "", value: "" }
                                    : { label: "", value: "" }
                                }
                                options={accountList2}
                                focus={!!formError?.party_account_id}
                                error={formError.party_account_id}
                              />
                            </div>
                          )}

                          <div className="singleDiv">
                            <div className="_attatchmentBxs">
                              <h4>Attachment</h4>

                              <div className="_athBxs">
                                <input
                                  type="file"
                                  id="_fileUpload"
                                  onChange={(e) =>
                                    handleFileChange(e, "second")
                                  }
                                  disabled={loading || form?.party_file?.length >= 5}
                                />
                                <label
                                  htmlFor="_fileUpload"
                                  className="_uploadBtn"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="19"
                                    viewBox="0 0 20 19"
                                    fill="none"
                                  >
                                    <path
                                      d="M5 0C6.28846 7.44425e-05 7.52716 0.497542 8.45778 1.38866C9.38839 2.27978 9.93908 3.49575 9.995 4.783L10 5V16C10.0008 16.7809 9.69698 17.5313 9.15323 18.0918C8.60948 18.6523 7.86861 18.9787 7.08804 19.0016C6.30747 19.0245 5.54873 18.7422 4.97303 18.2145C4.39733 17.6869 4.05006 16.9556 4.005 16.176L4 16V6C4.00028 5.74512 4.09788 5.49997 4.27285 5.31463C4.44782 5.1293 4.68695 5.01776 4.94139 5.00283C5.19584 4.98789 5.44638 5.07067 5.64183 5.23426C5.83729 5.39785 5.9629 5.6299 5.993 5.883L6 6V16C6.00028 16.2549 6.09788 16.5 6.27285 16.6854C6.44782 16.8707 6.68695 16.9822 6.94139 16.9972C7.19584 17.0121 7.44638 16.9293 7.64183 16.7657C7.83729 16.6021 7.9629 16.3701 7.993 16.117L8 16V5C8.00075 4.21909 7.69698 3.46867 7.15323 2.90818C6.60948 2.34769 5.86861 2.02132 5.08804 1.9984C4.30747 1.97548 3.54873 2.25784 2.97303 2.78546C2.39733 3.31309 2.05006 4.0444 2.005 4.824L2 5V14C1.99972 14.2549 1.90212 14.5 1.72715 14.6854C1.55218 14.8707 1.31305 14.9822 1.05861 14.9972C0.804163 15.0121 0.553621 14.9293 0.358167 14.7657C0.162714 14.6021 0.0371036 14.3701 0.00699997 14.117L0 14V5C0 3.67392 0.526784 2.40215 1.46447 1.46447C2.40215 0.526784 3.67392 0 5 0ZM13 14H15C15.2549 14.0003 15.5 14.0979 15.6854 14.2728C15.8707 14.4478 15.9822 14.687 15.9972 14.9414C16.0121 15.1958 15.9293 15.4464 15.7657 15.6418C15.6021 15.8373 15.3701 15.9629 15.117 15.993L15 16H13C12.7451 15.9997 12.5 15.9021 12.3146 15.7272C12.1293 15.5522 12.0178 15.313 12.0028 15.0586C11.9879 14.8042 12.0707 14.5536 12.2343 14.3582C12.3979 14.1627 12.6299 14.0371 12.883 14.007L13 14ZM13 10H18.5C18.7549 10.0003 19 10.0979 19.1854 10.2728C19.3707 10.4478 19.4822 10.687 19.4972 10.9414C19.5121 11.1958 19.4293 11.4464 19.2657 11.6418C19.1021 11.8373 18.8701 11.9629 18.617 11.993L18.5 12H13C12.7451 11.9997 12.5 11.9021 12.3146 11.7272C12.1293 11.5522 12.0178 11.313 12.0028 11.0586C11.9879 10.8042 12.0707 10.5536 12.2343 10.3582C12.3979 10.1627 12.6299 10.0371 12.883 10.007L13 10ZM13 6H18.5C18.7549 6.00028 19 6.09788 19.1854 6.27285C19.3707 6.44782 19.4822 6.68695 19.4972 6.94139C19.5121 7.19584 19.4293 7.44638 19.2657 7.64183C19.1021 7.83729 18.8701 7.9629 18.617 7.993L18.5 8H13C12.7451 7.99972 12.5 7.90212 12.3146 7.72715C12.1293 7.55218 12.0178 7.31305 12.0028 7.05861C11.9879 6.80416 12.0707 6.55362 12.2343 6.35817C12.3979 6.16271 12.6299 6.0371 12.883 6.007L13 6ZM13 2H18.5C18.7549 2.00028 19 2.09788 19.1854 2.27285C19.3707 2.44782 19.4822 2.68695 19.4972 2.94139C19.5121 3.19584 19.4293 3.44638 19.2657 3.64183C19.1021 3.83729 18.8701 3.9629 18.617 3.993L18.5 4H13C12.7451 3.99972 12.5 3.90212 12.3146 3.72715C12.1293 3.55218 12.0178 3.31305 12.0028 3.05861C11.9879 2.80416 12.0707 2.55362 12.2343 2.35817C12.3979 2.16271 12.6299 2.0371 12.883 2.007L13 2Z"
                                      fill="#1956F6"
                                    />
                                  </svg>
                                  <span>
                                    {loading ? "Uploadding" : "Add File"}
                                  </span>
                                </label>
                                {formError?.party_file && (
                                  <span className="input_drop_error">
                                    {formError?.party_file}
                                  </span>
                                )}
                              </div>
                              <div className="img_fnex_src">
                                {form?.party_file?.length > 0 &&
                                  form?.party_file?.map((el, index) => {
                                    return (
                                      <>
                                        <div className="pos-relative">
                                          <img
                                            className="_pdfIcon_sigxe"
                                            src={`${masterData?.s3_url}${el?.path}`}
                                            alt=""
                                          />
                                          <span className="_clDel_icon">
                                            <IoCloseCircle
                                              onClick={() =>
                                                partyDocumentRemove(index)
                                              }
                                            />
                                          </span>
                                        </div>
                                      </>
                                    );
                                  })}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="_balSuccess">
                    <p>Balance</p>

                    <p>
                      {(
                        props?.transactionList?.freight_summary?.freight_summary
                          ?.balance - form?.amount
                      ).toFixed(2)}
                    </p>
                  </div>
                </>
              )}
              <div className="offcanvas-footer">
                {userSettingPermission?.trip_payment_approval != 1 && <LoaderButton
                  onClick={() => onSubmitClaim(0)}
                  isLoading={isLoadding}
                  isLoadingText="Processing..."
                  className="_submitOn_modal"
                  disabled={isLoadding}
                >
                  {form?.sub_category === 2
                    ? "Charge Supplier"
                    : "Pay Supplier"}
                </LoaderButton>}
                <LoaderButton
                  onClick={() => onSubmitClaim(1)}
                  isLoadingText="Processing..."
                  className=" _submitOn_modal_white"
                  loaderClass="custom-spinner"
                  disabled={isloadingSend}
                  isLoading={isloadingSend}
                >
                  Send for Approval
                </LoaderButton>

              </div>
              {/* {form.submitType === 1 ? (
                  <div className="offcanvas-footer">
                    <button
                      className=" _submitOn_modal"
                      onClick={continueHnadle}
                      disabled={
                        form?.sub_category == 1
                          ? props?.userPermission?.add_claim_payable
                            ? false
                            : true
                          : props?.userPermission?.add_claim_receivable
                          ? false
                          : true
                      }
                    >
                      Continue
                    </button>
                  </div>
                ) : (
                  <div className="offcanvas-footer">
                    <button
                      className=" _submitOn_modal"
                      disabled={isLoadding}
                      onClick={() => onSubmitClaim(1)}
                    >
                      Approve
                    </button>
                    <button
                      className=" _submitOn_modal"
                      disabled={isLoadding}
                      onClick={() => onSubmitClaim(0)}
                    >
                      Save
                    </button>
                  </div>
                )} */}
            </>
            {/* ) : (
              <Loading />
            )} */}
          </>
        )}
      </div>
      <div className={isOpen ? "offBack_drop" : ""}></div>
      {isOpenFuelModal && <AddEditModal
        {...openZoneModal}
      />}
    </div>
  );
};

export default ClaimCanvas;
